// src/pages/AyarlarPage.js
import React, { useEffect, useMemo, useState } from "react";
import ResimUpload from "../ResimUpload";
import { API_BASE, UPLOAD_BASE, ORIGIN_BASE } from "../config";

/* ===========================================================
   DİL METİNLERİ
   =========================================================== */

const TEXTS = {
  tr: {
    settings: "Ayarlar",
    subtitle:
      "Kurum bilgileri, panel görünürlüğü, içerik dilleri ve kullanıcı yetkilerini tek merkezden yönetin.",

    uiLanguage: "Arayüz Dili",
    contentLanguages: "İçerik Dilleri",
    editedLanguage: "Düzenlenen içerik dili",

    institutionInfo: "Kurum Bilgileri",
    institutionInfoDesc:
      "Kurum adı, slogan, yetkili ve iletişim bilgilerini yönetin.",

    companyName: "Kurum / Firma Adı",
    slogan: "Slogan",
    branch: "Mahalle / Şube Adı",
    authorized: "Yetkili Adı",
    city: "İl",
    district: "İlçe",
    phone: "Telefon",
    email: "E-Posta",
    website: "Web Sitesi",

    logoBrand: "Logo & Marka",
    logoBrandDesc:
      "Panel ve mobil uygulamada kullanılacak kurum görselini yönetin.",
    logoUpload: "Logo Yükle",
    logoUrl: "Logo bağlantısı",
    logoHint:
      "Kare veya yatay logo kullanabilirsiniz. Yüklenen görsel mevcut upload sisteminizle kaydedilir.",

    socialTheme: "Sosyal Medya & Tema",
    socialThemeDesc:
      "Kurumsal sosyal medya hesapları ve panel görünümünü yönetin.",

    facebook: "Facebook",
    instagram: "Instagram",
    twitter: "Twitter / X",
    linkedin: "LinkedIn",
    youtube: "YouTube",

    theme: "Tema",
    lightTheme: "Açık Tema",
    lightThemeDesc: "Aydınlık ve sade panel görünümü",
    darkTheme: "Koyu Tema",
    darkThemeDesc: "Koyu ve yüksek kontrastlı panel görünümü",

    menuServiceSettings: "Menü / Hizmet Özellikleri",
    menuServiceSettingsDesc:
      "QR menü ve alerjen gösterimini yönetin.",
    menuEnabled: "Menü / Fiyat Listesi",
    menuEnabledDesc:
      "Kafe, restoran, hizmet listesi ve fiyat kataloğunu aktif eder.",
    allergensEnabled: "Alerji Bilgileri",
    allergensEnabledDesc:
      "Gluten, laktoz, fıstık ve diğer alerjen bilgilerini gösterir.",

    panelMenuVisibility: "Panel Menü Görünürlüğü",
    panelMenuVisibilityDesc:
      "Sol menüde hangi modüllerin görüneceğini kurum bazında belirleyin.",
    settingsLogoutAlways:
      "Ayarlar ve Çıkış güvenlik için daima görünür kalır.",
    searchMenu: "Menü ara...",
    enabledMenus: "aktif menü",
    enableAll: "Tümünü Aç",
    disableAll: "Hepsini Kapat",
    noMenuResult: "Aramanızla eşleşen menü bulunamadı.",

    marketplaceVisibility: "Kurum Kullanıcı Görünürlüğü",
    marketplaceVisibilityDesc:
      "Kullanıcılar hangi kurumları görebilsin?",
    marketplaceAll: "Tüm kurumlar",
    marketplaceOtherSector: "Kendi sektörüm dışındaki kurumlar",

    downloads: "Dosya & Link Paylaşımları",
    downloadsDesc:
      "Kullanıcılara gösterilecek PDF, belge, katalog veya internet bağlantılarını yönetin.",
    newDownload: "Yeni Dosya / Link Ekle",
    editDownload: "Dosya / Link Güncelle",
    title: "Başlık",
    description: "Açıklama",
    uploadFile: "Dosya Yükle",
    file: "Dosya",
    link: "Link",
    noDownloads: "Henüz eklenmiş dosya veya bağlantı yok.",
    add: "Ekle",
    update: "Güncelle",
    clear: "Temizle",
    edit: "Düzenle",
     delete: "Sil",
    untitled: "Başlıksız",
    send: "Gönder",
    sending: "Gönderiliyor...",
    downloadSent:
      "Dosya bildirimi kullanıcılara gönderildi.",
    downloadSendFailed:
      "Dosya bildirimi gönderilemedi.",

    changePassword: "Şifre Değiştir",

    changePassword: "Şifre Değiştir",
    changePasswordDesc:
      "Mevcut şifrenizi girerek yeni şifre belirleyin.",
    currentPassword: "Mevcut şifre",
    newPassword: "Yeni şifre",
    repeatPassword: "Yeni şifre tekrar",
    updatePassword: "Şifreyi Güncelle",

    usersAuthorization: "Kullanıcılar & Yetkilendirme",
    usersAuthorizationDesc:
      "Garson, kasiyer, müdür, stok sorumlusu veya özel kullanıcı oluşturun.",
    newUser: "Yeni Kullanıcı",
    editUser: "Kullanıcı Düzenle",
    fullName: "Ad Soyad",
    username: "Kullanıcı Maili",
    password: "Şifre",
    optionalPassword: "Yeni Şifre (isteğe bağlı)",
    role: "Rol",
    branchPermission: "Şube Yetkisi",
    allBranches: "Tüm şubeler",
    selectedBranch: "Sadece seçili şube",
    customBranch: "Özel şube kapsamı",
    branchName: "Şube Adı / Kapsam Notu",
    activeUser: "Aktif Kullanıcı",
    activeUserDesc: "Pasif kullanıcı sisteme giriş yapamaz.",
    internalNote: "İç not",
    saveUser: "Kullanıcı Ekle",
    updateUser: "Güncelle",
    modulePermissions: "Modül Yetkileri",
    modulePermissionsDesc:
      "Kullanıcının görebileceği ekranları ve yapabileceği işlemleri belirleyin.",
    selectAll: "Hepsini Seç",
    clearAll: "Hepsini Kapat",
    selectedPermission: "Seçili yetki",
    all: "Tümü",
    definedUsers: "Tanımlı Kullanıcılar",
    noDefinedUsers: "Henüz personel kullanıcısı eklenmedi.",
    active: "Aktif",
    passive: "Pasif",
    makePassive: "Pasif Yap",
    makeActive: "Aktif Yap",

    saveChanges: "Değişiklikleri Kaydet",
    saving: "Kaydediliyor...",
    saved: "Ayarlar başarıyla kaydedildi.",
    saveFailed: "Ayarlar kaydedilemedi.",
    serverError: "Sunucu hatası oluştu.",
    sessionNotFound: "Oturum bulunamadı.",

    profileCompletion: "Kurum profili",
    menuVisibility: "Menü görünürlüğü",
    languageCount: "İçerik dili",
    quickAccess: "Hızlı Erişim",
    security: "Güvenlik",
    users: "Kullanıcılar",

    fillAllFields: "Lütfen tüm alanları doldurun.",
    passwordsNotMatch: "Yeni şifreler birbiriyle uyuşmuyor.",
    passwordMin: "Yeni şifre en az 6 karakter olmalıdır.",
    passwordUpdated: "Şifre başarıyla güncellendi.",
    passwordUpdateFailed: "Şifre değiştirilemedi.",

    moduleSyncInfo:
      "Siparişler, Randevular, Mezarlıklar, Muhasebe, Dijital İmza ve Kuaför & Güzellik seçimleri mevcut ayar endpointleriyle otomatik olarak eşitlenir.",
  },

  en: {
    settings: "Settings",
    subtitle:
      "Manage organization details, panel visibility, content languages and user permissions from one place.",

    uiLanguage: "Interface Language",
    contentLanguages: "Content Languages",
    editedLanguage: "Editing content language",

    institutionInfo: "Organization Details",
    institutionInfoDesc:
      "Manage organization name, slogan, authorized person and contact information.",

    companyName: "Organization / Company Name",
    slogan: "Slogan",
    branch: "Neighborhood / Branch",
    authorized: "Authorized Person",
    city: "City",
    district: "District",
    phone: "Phone",
    email: "Email",
    website: "Website",

    logoBrand: "Logo & Brand",
    logoBrandDesc:
      "Manage the organization image used in the panel and mobile application.",
    logoUpload: "Upload Logo",
    logoUrl: "Logo URL",
    logoHint:
      "You can use a square or horizontal logo. The uploaded image is saved through your current upload system.",

    socialTheme: "Social Media & Theme",
    socialThemeDesc:
      "Manage corporate social media accounts and panel appearance.",

    facebook: "Facebook",
    instagram: "Instagram",
    twitter: "Twitter / X",
    linkedin: "LinkedIn",
    youtube: "YouTube",

    theme: "Theme",
    lightTheme: "Light Theme",
    lightThemeDesc: "Bright and clean panel appearance",
    darkTheme: "Dark Theme",
    darkThemeDesc: "Dark and high-contrast panel appearance",

    menuServiceSettings: "Menu / Service Features",
    menuServiceSettingsDesc:
      "Manage QR menu and allergen information.",
    menuEnabled: "Menu / Price List",
    menuEnabledDesc:
      "Enables cafe, restaurant, service list and price catalog.",
    allergensEnabled: "Allergen Information",
    allergensEnabledDesc:
      "Shows gluten, lactose, peanuts and other allergen information.",

    panelMenuVisibility: "Panel Menu Visibility",
    panelMenuVisibilityDesc:
      "Choose which modules appear in the left menu for this organization.",
    settingsLogoutAlways:
      "Settings and Logout always remain visible for security.",
    searchMenu: "Search menu...",
    enabledMenus: "active menus",
    enableAll: "Enable All",
    disableAll: "Disable All",
    noMenuResult: "No menu item matches your search.",

    marketplaceVisibility: "Organization Visibility",
    marketplaceVisibilityDesc:
      "Which organizations can users see?",
    marketplaceAll: "All organizations",
    marketplaceOtherSector: "Organizations outside my sector",

    downloads: "Files & Links",
    downloadsDesc:
      "Manage PDFs, documents, catalogs or web links shown to users.",
    newDownload: "Add File / Link",
    editDownload: "Update File / Link",
    title: "Title",
    description: "Description",
    uploadFile: "Upload File",
    file: "File",
    link: "Link",
    noDownloads: "No files or links have been added yet.",
    add: "Add",
    update: "Update",
    clear: "Clear",
    edit: "Edit",
       delete: "Delete",
    untitled: "Untitled",
    send: "Send",
    sending: "Sending...",
    downloadSent:
      "The file notification was sent to users.",
    downloadSendFailed:
      "The file notification could not be sent.",

    changePassword: "Change Password",
    changePasswordDesc:
      "Set a new password by entering your current password.",
    currentPassword: "Current password",
    newPassword: "New password",
    repeatPassword: "Repeat new password",
    updatePassword: "Update Password",

    usersAuthorization: "Users & Authorization",
    usersAuthorizationDesc:
      "Create waiter, cashier, manager, stock manager or custom users.",
    newUser: "New User",
    editUser: "Edit User",
    fullName: "Full Name",
    username: "User Email",
    password: "Password",
    optionalPassword: "New Password (optional)",
    role: "Role",
    branchPermission: "Branch Permission",
    allBranches: "All branches",
    selectedBranch: "Selected branch only",
    customBranch: "Custom branch scope",
    branchName: "Branch Name / Scope Note",
    activeUser: "Active User",
    activeUserDesc: "Inactive users cannot sign in.",
    internalNote: "Internal note",
    saveUser: "Add User",
    updateUser: "Update",
    modulePermissions: "Module Permissions",
    modulePermissionsDesc:
      "Choose which screens the user can see and which actions they can perform.",
    selectAll: "Select All",
    clearAll: "Clear All",
    selectedPermission: "Selected permissions",
    all: "All",
    definedUsers: "Defined Users",
    noDefinedUsers: "No personnel user has been added yet.",
    active: "Active",
    passive: "Inactive",
    makePassive: "Deactivate",
    makeActive: "Activate",

    saveChanges: "Save Changes",
    saving: "Saving...",
    saved: "Settings saved successfully.",
    saveFailed: "Settings could not be saved.",
    serverError: "A server error occurred.",
    sessionNotFound: "Session not found.",

    profileCompletion: "Organization profile",
    menuVisibility: "Menu visibility",
    languageCount: "Content languages",
    quickAccess: "Quick Access",
    security: "Security",
    users: "Users",

    fillAllFields: "Please fill in all fields.",
    passwordsNotMatch: "New passwords do not match.",
    passwordMin: "The new password must be at least 6 characters.",
    passwordUpdated: "Password updated successfully.",
    passwordUpdateFailed: "Password could not be updated.",

    moduleSyncInfo:
      "Orders, Appointments, Cemetery, Accounting, Digital Signature and Beauty selections are automatically synchronized with the existing settings endpoints.",
  },

  de: {
    settings: "Einstellungen",
    subtitle:
      "Organisationsdaten, Menü-Sichtbarkeit, Inhaltssprachen und Benutzerrechte zentral verwalten.",

    uiLanguage: "Oberflächensprache",
    contentLanguages: "Inhaltssprachen",
    editedLanguage: "Bearbeitete Inhaltssprache",

    institutionInfo: "Organisationsdaten",
    institutionInfoDesc:
      "Name, Slogan, verantwortliche Person und Kontaktdaten verwalten.",

    companyName: "Organisation / Firmenname",
    slogan: "Slogan",
    branch: "Stadtteil / Filiale",
    authorized: "Verantwortliche Person",
    city: "Stadt",
    district: "Bezirk",
    phone: "Telefon",
    email: "E-Mail",
    website: "Webseite",

    logoBrand: "Logo & Marke",
    logoBrandDesc:
      "Organisationsbild für Panel und mobile Anwendung verwalten.",
    logoUpload: "Logo hochladen",
    logoUrl: "Logo-URL",
    logoHint:
      "Sie können ein quadratisches oder horizontales Logo verwenden. Das Bild wird über das bestehende Upload-System gespeichert.",

    socialTheme: "Soziale Medien & Theme",
    socialThemeDesc:
      "Unternehmenskonten und Panel-Darstellung verwalten.",

    facebook: "Facebook",
    instagram: "Instagram",
    twitter: "Twitter / X",
    linkedin: "LinkedIn",
    youtube: "YouTube",

    theme: "Theme",
    lightTheme: "Helles Theme",
    lightThemeDesc: "Helle und übersichtliche Panel-Darstellung",
    darkTheme: "Dunkles Theme",
    darkThemeDesc: "Dunkle und kontrastreiche Panel-Darstellung",

    menuServiceSettings: "Menü- / Servicefunktionen",
    menuServiceSettingsDesc:
      "QR-Menü und Allergeninformationen verwalten.",
    menuEnabled: "Menü / Preisliste",
    menuEnabledDesc:
      "Aktiviert Café-, Restaurant-, Service- und Preislisten.",
    allergensEnabled: "Allergeninformationen",
    allergensEnabledDesc:
      "Zeigt Gluten, Laktose, Erdnüsse und weitere Allergene.",

    panelMenuVisibility: "Sichtbarkeit des Panel-Menüs",
    panelMenuVisibilityDesc:
      "Legen Sie fest, welche Module im linken Menü erscheinen.",
    settingsLogoutAlways:
      "Einstellungen und Abmelden bleiben aus Sicherheitsgründen immer sichtbar.",
    searchMenu: "Menü suchen...",
    enabledMenus: "aktive Menüs",
    enableAll: "Alle aktivieren",
    disableAll: "Alle deaktivieren",
    noMenuResult: "Kein Menüpunkt entspricht Ihrer Suche.",

    marketplaceVisibility: "Organisationssichtbarkeit",
    marketplaceVisibilityDesc:
      "Welche Organisationen können Benutzer sehen?",
    marketplaceAll: "Alle Organisationen",
    marketplaceOtherSector: "Organisationen außerhalb meiner Branche",

    downloads: "Dateien & Links",
    downloadsDesc:
      "PDFs, Dokumente, Kataloge oder Internetlinks für Benutzer verwalten.",
    newDownload: "Datei / Link hinzufügen",
    editDownload: "Datei / Link aktualisieren",
    title: "Titel",
    description: "Beschreibung",
    uploadFile: "Datei hochladen",
    file: "Datei",
    link: "Link",
    noDownloads: "Noch keine Dateien oder Links vorhanden.",
    add: "Hinzufügen",
    update: "Aktualisieren",
    clear: "Leeren",
    edit: "Bearbeiten",

       delete: "Löschen",
    untitled: "Ohne Titel",
    send: "Senden",
    sending: "Wird gesendet...",
    downloadSent:
      "Die Dateibenachrichtigung wurde gesendet.",
    downloadSendFailed:
      "Die Dateibenachrichtigung konnte nicht gesendet werden.",

    changePassword: "Passwort ändern",
    changePasswordDesc:
      "Legen Sie mit Ihrem aktuellen Passwort ein neues Passwort fest.",
    currentPassword: "Aktuelles Passwort",
    newPassword: "Neues Passwort",
    repeatPassword: "Neues Passwort wiederholen",
    updatePassword: "Passwort aktualisieren",

    usersAuthorization: "Benutzer & Berechtigungen",
    usersAuthorizationDesc:
      "Kellner, Kassierer, Manager, Lagerverantwortliche oder benutzerdefinierte Benutzer erstellen.",
    newUser: "Neuer Benutzer",
    editUser: "Benutzer bearbeiten",
    fullName: "Vor- und Nachname",
    username: "Benutzer-E-Mail",
    password: "Passwort",
    optionalPassword: "Neues Passwort (optional)",
    role: "Rolle",
    branchPermission: "Filialberechtigung",
    allBranches: "Alle Filialen",
    selectedBranch: "Nur ausgewählte Filiale",
    customBranch: "Benutzerdefinierter Filialbereich",
    branchName: "Filialname / Bereichsnotiz",
    activeUser: "Aktiver Benutzer",
    activeUserDesc: "Inaktive Benutzer können sich nicht anmelden.",
    internalNote: "Interne Notiz",
    saveUser: "Benutzer hinzufügen",
    updateUser: "Aktualisieren",
    modulePermissions: "Modulberechtigungen",
    modulePermissionsDesc:
      "Bestimmen Sie, welche Bildschirme und Aktionen der Benutzer verwenden kann.",
    selectAll: "Alle auswählen",
    clearAll: "Alle deaktivieren",
    selectedPermission: "Ausgewählte Berechtigungen",
    all: "Alle",
    definedUsers: "Definierte Benutzer",
    noDefinedUsers: "Noch kein Personalbenutzer hinzugefügt.",
    active: "Aktiv",
    passive: "Inaktiv",
    makePassive: "Deaktivieren",
    makeActive: "Aktivieren",

    saveChanges: "Änderungen speichern",
    saving: "Wird gespeichert...",
    saved: "Einstellungen erfolgreich gespeichert.",
    saveFailed: "Einstellungen konnten nicht gespeichert werden.",
    serverError: "Ein Serverfehler ist aufgetreten.",
    sessionNotFound: "Sitzung nicht gefunden.",

    profileCompletion: "Organisationsprofil",
    menuVisibility: "Menü-Sichtbarkeit",
    languageCount: "Inhaltssprachen",
    quickAccess: "Schnellzugriff",
    security: "Sicherheit",
    users: "Benutzer",

    fillAllFields: "Bitte füllen Sie alle Felder aus.",
    passwordsNotMatch: "Die neuen Passwörter stimmen nicht überein.",
    passwordMin: "Das neue Passwort muss mindestens 6 Zeichen lang sein.",
    passwordUpdated: "Passwort erfolgreich aktualisiert.",
    passwordUpdateFailed: "Passwort konnte nicht aktualisiert werden.",

    moduleSyncInfo:
      "Bestellungen, Termine, Friedhof, Buchhaltung, digitale Signatur und Beauty werden automatisch mit den bestehenden Einstellungs-Endpunkten synchronisiert.",
  },
};

/* ===========================================================
   DİLLER
   =========================================================== */

const LANGUAGES = [
  { code: "tr", label: "TR" },
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
];

/* ===========================================================
   PANEL MENÜLERİ
   CustomMenu.js anahtarlarıyla birebir aynıdır.
   =========================================================== */

const PANEL_MENU_ITEMS = [
  {
    key: "home",
    icon: "🏠",
    labels: {
      tr: "Ana Sayfa",
      en: "Home",
      de: "Startseite",
    },
    descriptions: {
      tr: "Panel ana ekranı ve genel özet",
      en: "Main dashboard and summary",
      de: "Haupt-Dashboard und Übersicht",
    },
  },
  {
    key: "menuManagement",
    icon: "🍽️",
    labels: {
      tr: "Menü Yönetimi",
      en: "Menu Management",
      de: "Menüverwaltung",
    },
    descriptions: {
      tr: "QR menü, ürün ve fiyat yönetimi",
      en: "QR menu, product and price management",
      de: "QR-Menü, Produkte und Preise",
    },
  },
  {
    key: "orders",
    icon: "📦",
    labels: {
      tr: "Siparişler",
      en: "Orders",
      de: "Bestellungen",
    },
    descriptions: {
      tr: "QR menü ve restoran siparişleri",
      en: "QR menu and restaurant orders",
      de: "QR-Menü- und Restaurantbestellungen",
    },
  },
  {
    key: "TelefonSiparis",
    icon: "☎️",
    labels: {
      tr: "Telefon Siparişi",
      en: "Phone Order",
      de: "Telefonbestellung",
    },
    descriptions: {
      tr: "Telefonla gelen müşteri siparişleri",
      en: "Customer orders received by phone",
      de: "Telefonisch aufgenommene Bestellungen",
    },
  },
  {
    key: "liveTables",
    icon: "🪑",
    labels: {
      tr: "Masa Yönetimi",
      en: "Table Management",
      de: "Tischverwaltung",
    },
    descriptions: {
      tr: "Masa, sipariş ve hesap takibi",
      en: "Table, order and bill tracking",
      de: "Tisch-, Bestell- und Rechnungsverfolgung",
    },
  },
  {
    key: "cashCollection",
    icon: "💰",
    labels: {
      tr: "Kasa & Tahsilat",
      en: "Cash & Collections",
      de: "Kasse & Zahlungen",
    },
    descriptions: {
      tr: "Gelir, gider ve tahsilat işlemleri",
      en: "Income, expense and payment operations",
      de: "Einnahmen, Ausgaben und Zahlungen",
    },
  },
  {
    key: "cari",
    icon: "👥",
    labels: {
      tr: "Cari / Müşteriler",
      en: "Customers / Current Accounts",
      de: "Kunden / Debitoren",
    },
    descriptions: {
      tr: "Müşteri ve cari hesap takibi",
      en: "Customer and current account tracking",
      de: "Kunden- und Debitorenverwaltung",
    },
  },
  {
    key: "stockManagement",
    icon: "📦",
    labels: {
      tr: "Stok Yönetimi",
      en: "Stock Management",
      de: "Lagerverwaltung",
    },
    descriptions: {
      tr: "Stok kartları, giriş, çıkış ve raporlar",
      en: "Stock cards, movements and reports",
      de: "Lagerkarten, Bewegungen und Berichte",
    },
  },
  {
    key: "marketplace",
    icon: "🏬",
    labels: {
      tr: "Pazar Yeri / Mağaza",
      en: "Marketplace / Store",
      de: "Marktplatz / Shop",
    },
    descriptions: {
      tr: "Ürün, hizmet ve kurum pazar yeri",
      en: "Product, service and organization marketplace",
      de: "Produkt-, Service- und Organisationsmarktplatz",
    },
  },
  {
    key: "integrations",
    icon: "🌐",
    labels: {
      tr: "Entegrasyonlar",
      en: "Integrations",
      de: "Integrationen",
    },
    descriptions: {
      tr: "Harici sistem ve API bağlantıları",
      en: "External system and API connections",
      de: "Externe Systeme und API-Verbindungen",
    },
  },
  {
    key: "fiscalPos",
    icon: "🧾",
    labels: {
      tr: "Yazar Kasa POS",
      en: "Fiscal POS",
      de: "Kassen-POS",
    },
    descriptions: {
      tr: "POS ve yazar kasa bağlantıları",
      en: "POS and fiscal cash register integrations",
      de: "POS- und Kassensystem-Integrationen",
    },
  },



  {
    key: "beauty",
    icon: "💇‍♀️",
    labels: {
      tr: "Kuaför & Güzellik",
      en: "Hairdresser & Beauty",
      de: "Friseur & Schönheit",
    },
    descriptions: {
      tr: "Müşteri, hizmet, paket ve seans yönetimi",
      en: "Customer, service, package and session management",
      de: "Kunden-, Service-, Paket- und Sitzungsverwaltung",
    },
  },


{
  key: "hotel",
  icon: "🏨",
  labels: {
    tr: "Otel Yönetimi",
    en: "Hotel Management",
    de: "Hotelverwaltung",
  },
  descriptions: {
    tr: "Rezervasyon, oda, misafir, ön büro, kat hizmetleri ve finans yönetimi",
    en: "Reservations, rooms, guests, front office, housekeeping and finance",
    de: "Reservierungen, Zimmer, Gäste, Rezeption, Housekeeping und Finanzen",
  },
},
{
  key: "mesyatPara",
  icon: "💳",
  labels: {
    tr: "MesYat Para Yönetimi",
    en: "MesYat Money Management",
    de: "MesYat-Geldverwaltung",
  },
  descriptions: {
    tr: "MesPuan görevleri, sponsor reklamları, indirimler, cüzdanlar ve risk yönetimi",
    en: "MesPuan tasks, sponsor campaigns, discounts, wallets and risk management",
    de: "MesPuan-Aufgaben, Sponsorkampagnen, Rabatte, Wallets und Risikomanagement",
  },
},
{
  key: "coursePrograms",




  icon: "🎓",
  labels: {
    tr: "Kurslar & Programlar",
    en: "Courses & Programs",
    de: "Kurse & Programme",
  },
  descriptions: {
    tr: "Kurs, eğitim, spor programı, öğrenci, yoklama ve ödeme yönetimi",
    en: "Course, training, sports program, student, attendance and payment management",
    de: "Kurse, Schulungen, Sportprogramme, Teilnehmer, Anwesenheit und Zahlungen",
  },
},
{
  key: "messageCenter",





    icon: "💬",
    labels: {
      tr: "Mesaj Merkezi",
      en: "Message Center",
      de: "Nachrichtenzentrale",
    },
    descriptions: {
      tr: "WhatsApp, e-posta ve otomatik mesajlar",
      en: "WhatsApp, email and automatic messages",
      de: "WhatsApp, E-Mail und automatische Nachrichten",
    },
  },
  {
    key: "businessNetwork",
    icon: "🤝",
    labels: {
      tr: "Üye İş Ağı ve CRM",
      en: "Member Network & CRM",
      de: "Mitgliedernetzwerk & CRM",
    },
    descriptions: {
      tr: "Üyeler, iş talepleri ve kurumlar arası iş birliği",
      en: "Members, business requests and collaboration",
      de: "Mitglieder, Aufträge und Zusammenarbeit",
    },
  },
  {
    key: "mainCategories",




    icon: "🗂️",
    labels: {
      tr: "Ana Kategoriler",
      en: "Main Categories",
      de: "Hauptkategorien",
    },
    descriptions: {
      tr: "Ana kategori yönetimi",
      en: "Main category management",
      de: "Hauptkategorie-Verwaltung",
    },
  },
  {
    key: "homepageManagement",
    icon: "ℹ️",
    labels: {
      tr: "Hakkımızda",
      en: "About Us",
      de: "Über uns",
    },
    descriptions: {
      tr: "Kurumsal tanıtım sayfası",
      en: "Corporate introduction page",
      de: "Unternehmensvorstellung",
    },
  },
  {
    key: "activities",
    icon: "📌",
    labels: {
      tr: "Faaliyetler",
      en: "Activities",
      de: "Aktivitäten",
    },
    descriptions: {
      tr: "Kurum faaliyet içerikleri",
      en: "Organization activity content",
      de: "Aktivitätsinhalte",
    },
  },
  {
    key: "announcements",
    icon: "📢",
    labels: {
      tr: "Duyurular",
      en: "Announcements",
      de: "Mitteilungen",
    },
    descriptions: {
      tr: "Kurum duyuruları",
      en: "Organization announcements",
      de: "Organisationsmitteilungen",
    },
  },
  {
    key: "events",
    icon: "📅",
    labels: {
      tr: "Etkinlikler",
      en: "Events",
      de: "Veranstaltungen",
    },
    descriptions: {
      tr: "Etkinlik ve organizasyon yönetimi",
      en: "Event and organization management",
      de: "Veranstaltungsverwaltung",
    },
  },
  {
    key: "documents",
    icon: "📁",
    labels: {
      tr: "Evraklarım",
      en: "My Documents",
      de: "Meine Dokumente",
    },
    descriptions: {
      tr: "Dosya ve evrak ekranı",
      en: "Files and documents",
      de: "Dateien und Dokumente",
    },
  },
  {
    key: "cemetery",
    icon: "🪦",
    labels: {
      tr: "Mezarlıklar",
      en: "Cemetery",
      de: "Friedhof",
    },
    descriptions: {
      tr: "QR mezarlık ve dijital anıt yönetimi",
      en: "QR cemetery and digital memorial management",
      de: "QR-Friedhof und digitales Denkmal",
    },
  },
  {
    key: "appointments",
    icon: "📅",
    labels: {
      tr: "Randevular",
      en: "Appointments",
      de: "Termine",
    },
    descriptions: {
      tr: "Randevu ve takvim yönetimi",
      en: "Appointment and calendar management",
      de: "Termin- und Kalenderverwaltung",
    },
  },
  {
    key: "accounting",
    icon: "🧾",
    labels: {
      tr: "Muhasebe",
      en: "Accounting",
      de: "Buchhaltung",
    },
    descriptions: {
      tr: "Muhasebe, vergi ve sigorta işlemleri",
      en: "Accounting, tax and insurance operations",
      de: "Buchhaltung, Steuern und Versicherung",
    },
  },
  {
    key: "digitalSignature",
    icon: "✍️",
    labels: {
      tr: "Dijital İmza",
      en: "Digital Signature",
      de: "Digitale Signatur",
    },
    descriptions: {
      tr: "Dijital evrak ve imza işlemleri",
      en: "Digital document and signature operations",
      de: "Digitale Dokumente und Signaturen",
    },
  },
  {
    key: "contact",
    icon: "☎️",
    labels: {
      tr: "İletişim",
      en: "Contact",
      de: "Kontakt",
    },
    descriptions: {
      tr: "Kurum iletişim bilgileri",
      en: "Organization contact information",
      de: "Kontaktinformationen",
    },
  },
  {
    key: "polls",
    icon: "📊",
    labels: {
      tr: "Anketler",
      en: "Polls",
      de: "Umfragen",
    },
    descriptions: {
      tr: "Anket oluşturma ve sonuçlar",
      en: "Poll creation and results",
      de: "Umfragen und Ergebnisse",
    },
  },
  {
    key: "feedback",
    icon: "💭",
    labels: {
      tr: "Geri Bildirim",
      en: "Feedback",
      de: "Rückmeldung",
    },
    descriptions: {
      tr: "Kullanıcı geri bildirimleri",
      en: "User feedback",
      de: "Benutzerrückmeldungen",
    },
  },
  {
    key: "qrCode",
    icon: "🔳",
    labels: {
      tr: "QR Kod",
      en: "QR Code",
      de: "QR-Code",
    },
    descriptions: {
      tr: "QR kod oluşturma ve yönetimi",
      en: "QR code creation and management",
      de: "QR-Code-Erstellung und Verwaltung",
    },
  },
  {
    key: "franchiseSystem",
    icon: "🤝",
    labels: {
      tr: "Bayilik Sistemi",
      en: "Partner System",
      de: "Partnersystem",
    },
    descriptions: {
      tr: "Bayi ve iş ortaklığı yönetimi",
      en: "Dealer and partner management",
      de: "Händler- und Partnerverwaltung",
    },
  },
  {
    key: "users",
    icon: "👤",
    labels: {
      tr: "Kullanıcılar",
      en: "Users",
      de: "Benutzer",
    },
    descriptions: {
      tr: "Panel kullanıcı yönetimi",
      en: "Panel user management",
      de: "Panel-Benutzerverwaltung",
    },
  },
];

const PANEL_MENU_KEYS = PANEL_MENU_ITEMS.map((item) => item.key);
const DEFAULT_VISIBLE_MENU_ITEMS = [...PANEL_MENU_KEYS];

const BUSINESS_NETWORK_MIGRATION_KEY =
  "app_business_network_menu_migrated_v2";

const PHONE_ORDER_MIGRATION_KEY =
  "app_phone_order_menu_migrated_v1";

const USER_SAVED_MENU_KEY =
  "app_visible_menu_items_user_saved";

/* ===========================================================
   YETKİ GRUPLARI
   =========================================================== */

const PERMISSION_GROUPS = [
  {
    title: "Dashboard & Ana Panel",
    description:
      "Ana ekran, genel kartlar, hızlı işlemler ve raporlar",
    items: [
      {
        key: "dashboard.view",
        label: "Dashboard ekranını görsün",
      },
      {
        key: "dashboard.stats",
        label: "İstatistik kartlarını görsün",
      },
      {
        key: "dashboard.quick_actions",
        label: "Hızlı işlem butonlarını görsün",
      },
      {
        key: "reports.view",
        label: "Genel raporları görsün",
      },
      {
        key: "reports.export",
        label: "Rapor dışa aktarabilsin",
      },
    ],
  },
  {
    title: "Kurum & Genel Ayarlar",
    description:
      "Firma, logo, dil, tema ve kullanıcı ayarları",
    items: [
      {
        key: "settings.view",
        label: "Ayarlar ekranını görsün",
      },
      {
        key: "settings.manage",
        label: "Genel ayarları değiştirsin",
      },
      {
        key: "company.info.manage",
        label: "Kurum bilgilerini düzenlesin",
      },
      {
        key: "company.logo.manage",
        label: "Logo yüklesin veya değiştirsin",
      },
      {
        key: "company.languages.manage",
        label: "Dilleri yönetsin",
      },
      {
        key: "company.theme.manage",
        label: "Tema ayarlarını değiştirsin",
      },
      {
        key: "users.manage",
        label: "Kullanıcı ve yetki yönetsin",
      },
    ],
  },
  {
    title: "QR Menü & Menü Yönetimi",
    description:
      "Kategoriler, ürünler, fiyatlar ve görseller",
    items: [
      {
        key: "menu.view",
        label: "QR menüyü görsün",
      },
      {
        key: "menu.manage",
        label: "QR menüyü yönetsin",
      },
      {
        key: "menu.settings.view",
        label: "Menü ayarlarını görsün",
      },
      {
        key: "menu.settings.manage",
        label: "Menü ayarlarını değiştirsin",
      },
      {
        key: "menu.main_categories.view",
        label: "Ana kategorileri görsün",
      },
      {
        key: "menu.main_categories.manage",
        label: "Ana kategorileri yönetsin",
      },
      {
        key: "menu.categories.view",
        label: "Alt kategorileri görsün",
      },
      {
        key: "menu.categories.manage",
        label: "Alt kategorileri yönetsin",
      },
      {
        key: "menu.products.view",
        label: "Ürünleri görsün",
      },
      {
        key: "menu.products.manage",
        label: "Ürünleri yönetsin",
      },
      {
        key: "menu.prices.manage",
        label: "Fiyatları değiştirsin",
      },
      {
        key: "menu.images.manage",
        label: "Görselleri değiştirsin",
      },
      {
        key: "menu.trend.manage",
        label: "Trend ürünleri yönetsin",
      },
      {
        key: "menu.allergens.manage",
        label: "Alerjen bilgilerini yönetsin",
      },
      {
        key: "menu.languages.manage",
        label: "Menü dillerini yönetsin",
      },
    ],
  },
  {
    title: "Sipariş & Masa",
    description:
      "Sipariş, telefon siparişi, masa ve garson çağırma",
    items: [
      {
        key: "orders.view",
        label: "Siparişleri görsün",
      },
      {
        key: "orders.create",
        label: "Sipariş oluşturabilsin",
      },
      {
        key: "orders.manage",
        label: "Sipariş durumunu değiştirsin",
      },
      {
        key: "orders.delete",
        label: "Sipariş silebilsin",
      },
      {
        key: "orders.print",
        label: "Sipariş yazdırabilsin",
      },
      {
        key: "phone_orders.view",
        label: "Telefon siparişlerini görsün",
      },
      {
        key: "phone_orders.manage",
        label: "Telefon siparişlerini yönetsin",
      },
      {
        key: "tables.view",
        label: "Masa ekranını görsün",
      },
      {
        key: "tables.manage",
        label: "Masa işlemlerini yönetsin",
      },
      {
        key: "waiter_call.view",
        label: "Garson çağrılarını görsün",
      },
      {
        key: "waiter_call.manage",
        label: "Garson çağrılarını yönetsin",
      },
    ],
  },
  {
    title: "Kasa & Tahsilat",
    description:
      "Gelir, gider, ödeme ve tahsilat işlemleri",
    items: [
      {
        key: "cash.view",
        label: "Kasayı görsün",
      },
      {
        key: "cash.create",
        label: "Kasa işlemi eklesin",
      },
      {
        key: "cash.manage",
        label: "Kasa işlemlerini düzenlesin",
      },
      {
        key: "cash.delete",
        label: "Kasa işlemi silebilsin",
      },
      {
        key: "cash.reports.view",
        label: "Kasa raporlarını görsün",
      },
      {
        key: "cash.export",
        label: "Kasa raporlarını dışa aktarsın",
      },
    ],
  },
  {
    title: "Cari & Müşteriler",
    description:
      "Cari hesap, borç, alacak ve tahsilatlar",
    items: [
      {
        key: "current.view",
        label: "Cari hesapları görsün",
      },
      {
        key: "current.create",
        label: "Cari hesap eklesin",
      },
      {
        key: "current.manage",
        label: "Cari kayıtları düzenlesin",
      },
      {
        key: "current.delete",
        label: "Cari kayıt silebilsin",
      },
      {
        key: "current.payments.view",
        label: "Tahsilat geçmişini görsün",
      },
      {
        key: "current.payments.manage",
        label: "Tahsilat işlemi yapabilsin",
      },
      {
        key: "current.reports.view",
        label: "Cari raporlarını görsün",
      },
    ],
  },
  {
    title: "Stok Yönetimi",
    description:
      "Stok kartları, giriş, çıkış, sayım ve raporlar",
    items: [
      {
        key: "stock.view",
        label: "Stok ekranını görsün",
      },
      {
        key: "stock.cards.view",
        label: "Stok kartlarını görsün",
      },
      {
        key: "stock.cards.manage",
        label: "Stok kartlarını yönetsin",
      },
      {
        key: "stock.entry.manage",
        label: "Stok girişi yapabilsin",
      },
      {
        key: "stock.out.manage",
        label: "Stok çıkışı yapabilsin",
      },
      {
        key: "stock.count.manage",
        label: "Stok sayımı yapabilsin",
      },
      {
        key: "stock.critical.view",
        label: "Kritik stokları görsün",
      },
      {
        key: "stock.movements.view",
        label: "Stok hareketlerini görsün",
      },
      {
        key: "stock.reports.view",
        label: "Stok raporlarını görsün",
      },
      {
        key: "stock.settings.manage",
        label: "Stok ayarlarını değiştirsin",
      },
    ],
  },
  {
    title: "Duyuru & Etkinlik",
    description:
      "Duyuru, etkinlik ve içerik yönetimi",
    items: [
      {
        key: "announcements.view",
        label: "Duyuruları görsün",
      },
      {
        key: "announcements.manage",
        label: "Duyuruları yönetsin",
      },
      {
        key: "events.view",
        label: "Etkinlikleri görsün",
      },
      {
        key: "events.manage",
        label: "Etkinlikleri yönetsin",
      },
      {
        key: "news.view",
        label: "Haber ve içerikleri görsün",
      },
      {
        key: "news.manage",
        label: "Haber ve içerikleri yönetsin",
      },
    ],
  },
  {
    title: "Anket & Geri Bildirim",
    description:
      "Anket, form, başvuru ve geri bildirimler",
    items: [
      {
        key: "surveys.view",
        label: "Anketleri görsün",
      },
      {
        key: "surveys.manage",
        label: "Anketleri yönetsin",
      },
      {
        key: "forms.view",
        label: "Form ve başvuruları görsün",
      },
      {
        key: "forms.manage",
        label: "Form ve başvuruları yönetsin",
      },
      {
        key: "feedback.view",
        label: "Geri bildirimleri görsün",
      },
      {
        key: "feedback.manage",
        label: "Geri bildirimleri yönetsin",
      },
    ],
  },
  {
    title: "Dosya & Link",
    description:
      "Belge, katalog, PDF ve bağlantılar",
    items: [
      {
        key: "files.view",
        label: "Dosyaları görsün",
      },
      {
        key: "files.manage",
        label: "Dosya ve linkleri yönetsin",
      },
      {
        key: "files.download",
        label: "Dosya indirebilsin",
      },
    ],
  },
  {
    title: "Randevu",
    description:
      "Randevu, takvim ve randevu ayarları",
    items: [
      {
        key: "appointments.view",
        label: "Randevuları görsün",
      },
      {
        key: "appointments.create",
        label: "Randevu oluşturabilsin",
      },
      {
        key: "appointments.manage",
        label: "Randevuları yönetsin",
      },
      {
        key: "appointments.calendar.view",
        label: "Takvimi görsün",
      },
      {
        key: "appointments.settings.manage",
        label: "Randevu ayarlarını yönetsin",
      },
    ],
  },
  {
    title: "Kuaför & Güzellik",
    description:
      "Müşteri, hizmet, paket, seans ve tahsilatlar",
    items: [
      {
        key: "beauty.view",
        label: "Beauty ekranını görsün",
      },
      {
        key: "beauty.customers.view",
        label: "Beauty müşterilerini görsün",
      },
      {
        key: "beauty.customers.manage",
        label: "Beauty müşterilerini yönetsin",
      },
      {
        key: "beauty.services.view",
        label: "Beauty hizmetlerini görsün",
      },
      {
        key: "beauty.services.manage",
        label: "Beauty hizmetlerini yönetsin",
      },
      {
        key: "beauty.packages.view",
        label: "Paketleri görsün",
      },
      {
        key: "beauty.packages.manage",
        label: "Paketleri yönetsin",
      },
      {
        key: "beauty.sessions.view",
        label: "Seansları görsün",
      },
      {
        key: "beauty.sessions.manage",
        label: "Seansları yönetsin",
      },
      {
        key: "beauty.payments.view",
        label: "Tahsilatları görsün",
      },
      {
        key: "beauty.payments.manage",
        label: "Tahsilatları yönetsin",
      },
      
      {
        key: "beauty.reports.view",
        label: "Beauty raporlarını görsün",
      },
    ],
  },
  {
    title: "Otel Yönetimi",
    description:
      "Rezervasyon, ön büro, oda, misafir, housekeeping, teknik servis ve finans işlemleri",
    items: [
      {
        key: "hotel.view",
        label: "Otel yönetim ekranını görsün",
      },
      {
        key: "hotel.manage",
        label: "Otel genel işlemlerini yönetsin",
      },
      {
        key: "hotel.reservations.view",
        label: "Rezervasyonları görsün",
      },
      {
        key: "hotel.reservations.manage",
        label: "Rezervasyon eklesin ve düzenlesin",
      },
      {
        key: "hotel.checkin.manage",
        label: "Check-in işlemi yapabilsin",
      },
      {
        key: "hotel.checkout.manage",
        label: "Check-out işlemi yapabilsin",
      },
      {
        key: "hotel.rooms.view",
        label: "Odaları ve oda tiplerini görsün",
      },
      {
        key: "hotel.rooms.manage",
        label: "Odaları ve oda tiplerini yönetsin",
      },
      {
        key: "hotel.guests.view",
        label: "Misafir kayıtlarını görsün",
      },
      {
        key: "hotel.guests.manage",
        label: "Misafir kayıtlarını yönetsin",
      },
      {
        key: "hotel.housekeeping.view",
        label: "Kat hizmetleri görevlerini görsün",
      },
      {
        key: "hotel.housekeeping.manage",
        label: "Kat hizmetleri görevlerini yönetsin",
      },
      {
        key: "hotel.maintenance.view",
        label: "Teknik servis kayıtlarını görsün",
      },
      {
        key: "hotel.maintenance.manage",
        label: "Teknik servis kayıtlarını yönetsin",
      },
      {
        key: "hotel.finance.view",
        label: "Folyo ve ödemeleri görsün",
      },
      {
        key: "hotel.finance.manage",
        label: "Harcama ve ödeme işlemi yapabilsin",
      },
      {
        key: "hotel.reports.view",
        label: "Otel raporlarını görsün",
      },
      {
        key: "hotel.settings.manage",
        label: "Otel ayarlarını değiştirsin",
      },
   
    ],
  },

   {
    title: "MesYat Para Yönetimi",
    description:
      "MesPuan görevleri, sponsor kampanyaları, Marketplace indirimleri, cüzdanlar ve risk kayıtları",
    items: [
      {
        key: "mespuan.view",
        label: "MesYat Para yönetim ekranını görsün",
      },
      {
        key: "mespuan.manage",
        label: "Görev, kampanya, indirim ve cüzdan işlemlerini yönetsin",
      },
    ],
  },

  {
    title: "Kurslar & Programlar",
    description:
      "Kurs, eğitim, spor programı, başvuru, öğrenci, yoklama, ödeme ve rapor yönetimi",


    items: [
      {
        key: "courses.view",
        label: "Kurs ve program yönetim ekranını görsün",
      },
      {
        key: "courses.manage",
        label: "Kurs, öğrenci, yoklama ve finans işlemlerini yönetsin",
      },
    ],
  },

  {
    title: "Mesaj Merkezi",
    description:
      "WhatsApp, e-posta ve otomatik mesajlar",

    items: [
      {
        key: "messages.view",
        label: "Mesaj merkezini görsün",
      },
      {
        key: "messages.send",
        label: "Mesaj gönderebilsin",
      },
      {
        key: "messages.templates.view",
        label: "Mesaj şablonlarını görsün",
      },
      {
        key: "messages.templates.manage",
        label: "Mesaj şablonlarını yönetsin",
      },
      {
        key: "messages.automation.view",
        label: "Otomatik mesajları görsün",
      },
      {
        key: "messages.automation.manage",
        label: "Otomatik mesajları yönetsin",
      },
      {
        key: "messages.logs.view",
        label: "Mesaj kayıtlarını görsün",
      },
    ],
  },
  {
    title: "Üye İş Ağı & CRM",
    description:
      "Üyeler, sektörler, iş talepleri ve teklifler",
    items: [
      {
        key: "business_network.view",
        label: "Üye İş Ağı ekranını görsün",
      },
      {
        key: "business_network.profile.manage",
        label: "Firma profilini düzenlesin",
      },
      {
        key: "business_network.members.view",
        label: "Üye listesini görsün",
      },
      {
        key: "business_network.members.manage",
        label: "Üyeleri yönetsin",
      },
      {
        key: "business_network.jobs.view",
        label: "İş taleplerini görsün",
      },
      {
        key: "business_network.jobs.manage",
        label: "İş taleplerini yönetsin",
      },
      {
        key: "business_network.catalogs.manage",
        label: "Sektör ve hizmetleri yönetsin",
      },
      {
        key: "business_network.settings.manage",
        label: "İş ağı ayarlarını değiştirsin",
      },
    ],
  },
  {
    title: "Dijital İmza",
    description:
      "Dijital evrak, imza ve arşiv",
    items: [
      {
        key: "digital_signature.view",
        label: "Dijital imza ekranını görsün",
      },
      {
        key: "digital_signature.create",
        label: "İmzaya evrak gönderebilsin",
      },
      {
        key: "digital_signature.manage",
        label: "İmza işlemlerini yönetsin",
      },
      {
        key: "digital_signature.archive.view",
        label: "İmzalı evrakları görsün",
      },
      {
        key: "digital_signature.settings.manage",
        label: "Dijital imza ayarlarını yönetsin",
      },
    ],
  },
  {
    title: "QR Mezarlık",
    description:
      "Dijital anıt, biyografi, galeri ve taziye",
    items: [
      {
        key: "memorial.view",
        label: "Mezarlık modülünü görsün",
      },
      {
        key: "memorial.records.view",
        label: "Anıt kayıtlarını görsün",
      },
      {
        key: "memorial.records.manage",
        label: "Anıt kayıtlarını yönetsin",
      },
      {
        key: "memorial.gallery.manage",
        label: "Fotoğraf ve videoları yönetsin",
      },
      {
        key: "memorial.condolences.view",
        label: "Taziye mesajlarını görsün",
      },
      {
        key: "memorial.condolences.manage",
        label: "Taziye mesajlarını yönetsin",
      },
      {
        key: "memorial.settings.manage",
        label: "Mezarlık ayarlarını yönetsin",
      },
    ],
  },
  {
    title: "Pazar Yeri",
    description:
      "Firma profili, ilanlar ve kurum görünürlüğü",
    items: [
      {
        key: "marketplace.view",
        label: "Pazar yerini görsün",
      },
      {
        key: "marketplace.visibility.manage",
        label: "Kurum görünürlüğünü yönetsin",
      },
      {
        key: "marketplace.profile.manage",
        label: "Firma profilini düzenlesin",
      },
      {
        key: "marketplace.listings.view",
        label: "İlanları görsün",
      },
      {
        key: "marketplace.listings.manage",
        label: "İlanları yönetsin",
      },
    ],
  },
  {
    title: "Şube & Bayilik",
    description:
      "Şubeler, bayiler ve konsolide raporlar",
    items: [
      {
        key: "branches.view",
        label: "Şubeleri görsün",
      },
      {
        key: "branches.manage",
        label: "Şubeleri yönetsin",
      },
      {
        key: "branches.consolidated.view",
        label: "Konsolide raporları görsün",
      },
      {
        key: "dealers.view",
        label: "Bayilik sistemini görsün",
      },
      {
        key: "dealers.manage",
        label: "Bayileri yönetsin",
      },
      {
        key: "dealers.commission.view",
        label: "Komisyon bilgilerini görsün",
      },
      {
        key: "dealers.commission.manage",
        label: "Komisyonları yönetsin",
      },
    ],
  },
  {
    title: "Muhasebe",
    description:
      "Muhasebe, vergi, evrak ve sigorta",
    items: [
      {
        key: "accounting.view",
        label: "Muhasebe modülünü görsün",
      },
      {
        key: "accounting.documents.view",
        label: "Muhasebe evraklarını görsün",
      },
      {
        key: "accounting.documents.manage",
        label: "Muhasebe evraklarını yönetsin",
      },
      {
        key: "accounting.tax.view",
        label: "Vergi süreçlerini görsün",
      },
      {
        key: "accounting.tax.manage",
        label: "Vergi süreçlerini yönetsin",
      },
      {
        key: "accounting.insurance.view",
        label: "Sigorta süreçlerini görsün",
      },
      {
        key: "accounting.insurance.manage",
        label: "Sigorta süreçlerini yönetsin",
      },
    ],
  },
  {
    title: "Sistem & Kritik İşlemler",
    description:
      "Loglar, destek, silme ve dışa aktarma",
    items: [
      {
        key: "system.logs.view",
        label: "İşlem loglarını görsün",
      },
      {
        key: "system.support.view",
        label: "Destek ekranını görsün",
      },
      {
        key: "system.delete_allowed",
        label: "Silme işlemi yapabilsin",
      },
      {
        key: "system.export_allowed",
        label: "Veri dışa aktarabilsin",
      },
      {
        key: "system.admin_tools",
        label: "Gelişmiş yönetici araçlarını görsün",
      },
    ],
  },
];

const ALL_PERMISSION_KEYS = PERMISSION_GROUPS.flatMap((group) =>
  group.items.map((item) => item.key)
);

const ROLE_PRESETS = {
  owner: {
    label: "Firma Sahibi / Tam Yetkili",
    description:
      "Tüm ekranları ve işlemleri kullanabilir.",
    permissions: ALL_PERMISSION_KEYS,
  },
  manager: {
    label: "Müdür",
    description:
      "Operasyon, menü, sipariş, stok ve rapor yönetimi.",
    permissions: [
      "dashboard.view",
      "dashboard.stats",
      "dashboard.quick_actions",
      "reports.view",
      "menu.view",
      "menu.manage",
      "menu.main_categories.view",
      "menu.main_categories.manage",
      "menu.categories.view",
      "menu.categories.manage",
      "menu.products.view",
      "menu.products.manage",
      "menu.prices.manage",
      "menu.images.manage",
      "orders.view",
      "orders.create",
      "orders.manage",
      "orders.print",
      "phone_orders.view",
      "phone_orders.manage",
      "tables.view",
      "tables.manage",
      "waiter_call.view",
      "waiter_call.manage",
      "cash.view",
      "cash.create",
      "cash.manage",
      "current.view",
      "stock.view",
      "stock.cards.view",
      "stock.cards.manage",
      "stock.entry.manage",
      "stock.out.manage",
      "stock.count.manage",
      "stock.movements.view",
      "stock.reports.view",
      "appointments.view",
      "appointments.create",
      "appointments.manage",
      "beauty.view",
      "beauty.customers.view",
      "beauty.services.view",
      "beauty.packages.view",
      "beauty.sessions.view",
      "announcements.view",
      "announcements.manage",
      "events.view",
      "events.manage",
      "files.view",
      "files.manage",
      "branches.view",
    ],
  },
  waiter: {
    label: "Garson",
    description:
      "Sipariş, masa ve garson çağırma işlemleri.",
    permissions: [
      "dashboard.view",
      "orders.view",
      "orders.create",
      "orders.manage",
      "orders.print",
      "tables.view",
      "waiter_call.view",
      "waiter_call.manage",
    ],
  },
  cashier: {
    label: "Kasiyer",
    description:
      "Sipariş, masa, kasa ve tahsilat işlemleri.",
    permissions: [
      "dashboard.view",
      "orders.view",
      "orders.create",
      "orders.manage",
      "orders.print",
      "phone_orders.view",
      "phone_orders.manage",
      "tables.view",
      "tables.manage",
      "cash.view",
      "cash.create",
      "cash.manage",
      "current.view",
      "current.payments.view",
      "current.payments.manage",
    ],
  },
  stock_staff: {
    label: "Stok Sorumlusu",
    description:
      "Stok kartları, hareketler, giriş, çıkış ve sayım.",
    permissions: [
      "dashboard.view",
      "stock.view",
      "stock.cards.view",
      "stock.cards.manage",
      "stock.entry.manage",
      "stock.out.manage",
      "stock.count.manage",
      "stock.critical.view",
      "stock.movements.view",
      "stock.reports.view",
    ],
  },
  menu_staff: {
    label: "Menü Sorumlusu",
    description:
      "Kategori, ürün, fiyat ve görsel yönetimi.",
    permissions: [
      "dashboard.view",
      "menu.view",
      "menu.manage",
      "menu.settings.view",
      "menu.main_categories.view",
      "menu.main_categories.manage",
      "menu.categories.view",
      "menu.categories.manage",
      "menu.products.view",
      "menu.products.manage",
      "menu.prices.manage",
      "menu.images.manage",
      "menu.trend.manage",
      "menu.allergens.manage",
      "menu.languages.manage",
    ],
  },
  content_staff: {
    label: "İçerik Sorumlusu",
    description:
      "Duyuru, etkinlik, anket, dosya ve içerikler.",
    permissions: [
      "dashboard.view",
      "announcements.view",
      "announcements.manage",
      "events.view",
      "events.manage",
      "news.view",
      "news.manage",
      "surveys.view",
      "surveys.manage",
      "forms.view",
      "forms.manage",
      "feedback.view",
      "feedback.manage",
      "files.view",
      "files.manage",
    ],
  },
  accounting_staff: {
    label: "Muhasebe / Cari Sorumlusu",
    description:
      "Cari, kasa, tahsilat ve muhasebe işlemleri.",
    permissions: [
      "dashboard.view",
      "reports.view",
      "reports.export",
      "cash.view",
      "cash.create",
      "cash.manage",
      "cash.reports.view",
      "cash.export",
      "current.view",
      "current.create",
      "current.manage",
      "current.payments.view",
      "current.payments.manage",
      "current.reports.view",
      "accounting.view",
      "accounting.documents.view",
      "accounting.documents.manage",
      "accounting.tax.view",
      "accounting.insurance.view",
    ],
  },
  beauty_staff: {
    label: "Beauty / Kuaför Personeli",
    description:
      "Beauty müşterileri, hizmetler, paketler ve seanslar.",
    permissions: [
      "dashboard.view",
      "appointments.view",
      "appointments.create",
      "appointments.manage",
      "appointments.calendar.view",
      "beauty.view",
      "beauty.customers.view",
      "beauty.customers.manage",
      "beauty.services.view",
      "beauty.packages.view",
      "beauty.sessions.view",
      "beauty.sessions.manage",
    ],
  },
  readonly: {
    label: "Sadece Görüntüleme",
    description:
      "İşlem yapmadan yalnızca izin verilen ekranları görür.",
    permissions: [
      "dashboard.view",
      "reports.view",
      "orders.view",
    ],
  },
  custom: {
    label: "Özel Rol",
    description:
      "Yetkiler tek tek belirlenir.",
    permissions: [],
  },
};

/* ===========================================================
   SABİTLER
   =========================================================== */

const SETTINGS_ENDPOINT_CANDIDATES = [
  "kurum-ayarlar",
  "kurum-ayar",
  "ayarlar",
  "settings",
];

const AUTH_USERS_ENDPOINT =
  `${API_BASE}/ayar-yetkilendirme`;

const ORIGIN =
  ORIGIN_BASE ||
  (typeof window !== "undefined"
    ? window.location.origin
    : "");

const UPLOAD_ROOT =
  UPLOAD_BASE && UPLOAD_BASE.trim()
    ? UPLOAD_BASE.trim()
    : "";

/* ===========================================================
   YARDIMCI FONKSİYONLAR
   =========================================================== */

function originWithoutPanel(originValue) {
  try {
    const url = new URL(originValue);

    if (url.hostname.startsWith("panel.")) {
      url.hostname = url.hostname.replace(/^panel\./, "");
    }

    return url.origin;
  } catch {
    return originValue;
  }
}

function normalizeUploadUrl(rawValue) {
  if (!rawValue) return "";

  let value = String(rawValue).trim();

  value = value.replace(/^http:\/\//i, "https://");

  if (
    !/^https?:\/\//i.test(value) &&
    !value.startsWith("/")
  ) {
    value = `/uploads/${value}`;
  }

  const stripUploadFolder = (pathname) =>
    pathname
      .replace(/^\/?(upload|uploads)\//i, "")
      .replace(/^\/+/, "");

  try {
    const absoluteUrl = new URL(value, ORIGIN);
    const filePart = stripUploadFolder(
      absoluteUrl.pathname
    );

    const selectedOrigin = UPLOAD_ROOT
      ? new URL(UPLOAD_ROOT, ORIGIN).origin
      : originWithoutPanel(ORIGIN);

    const baseUrl = new URL(
      UPLOAD_ROOT || "/uploads",
      selectedOrigin
    );

    let basePath = baseUrl.pathname.replace(/\/+$/, "");

    if (!/(\/upload(s)?)$/i.test(basePath)) {
      basePath += "/uploads";
    }

    return `${baseUrl.origin}${basePath}/${filePart}`;
  } catch {
    return value;
  }
}

function normalizeVisibleMenuItems(
  rawValue,
  fallback = DEFAULT_VISIBLE_MENU_ITEMS
) {
  if (
    rawValue === undefined ||
    rawValue === null
  ) {
    return [...fallback];
  }

  let value = rawValue;

  if (typeof value === "string") {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return [...fallback];
    }

    try {
      value = JSON.parse(trimmedValue);
    } catch {
      value = trimmedValue
        .split(",")
        .map((item) => item.trim())
        .filter(Boolean);
    }
  }

  if (!Array.isArray(value)) {
    return [...fallback];
  }

  const allowedKeys = new Set(PANEL_MENU_KEYS);

  return [
    ...new Set(
      value
        .map(String)
        .filter((key) => allowedKeys.has(key))
    ),
  ];
}

function createPermissionMap(selectedKeys = []) {
  return ALL_PERMISSION_KEYS.reduce(
    (result, permissionKey) => {
      result[permissionKey] =
        selectedKeys.includes(permissionKey);

      return result;
    },
    {}
  );
}

function createAuthDraft() {
  return {
    id: null,
    name: "",
    username: "",
    password: "",
    role: "waiter",
    active: true,
    branchScope: "all",
    branchName: "",
    notes: "",
    permissions: createPermissionMap(
      ROLE_PRESETS.waiter.permissions
    ),
  };
}

function normalizeAuthUser(user) {
  return {
    ...createAuthDraft(),
    id: user?.id ?? null,
    name: user?.name || "",
    username: user?.username || "",
    password: "",
    role: user?.role || "custom",
    active: user?.active === true,
    branchScope:
      user?.branchScope ||
      user?.branch_scope ||
      "all",
    branchName:
      user?.branchName ||
      user?.branch_name ||
      "",
    notes: user?.notes || "",
    permissions: {
      ...createPermissionMap(),
      ...(user?.permissions || {}),
    },
    password_set:
      user?.password_set === true,
    last_login_at:
      user?.last_login_at || null,
    created_at:
      user?.created_at || null,
    updated_at:
      user?.updated_at || null,
  };
}

function authHeaders(token) {
  return {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
}

async function getSettingsFromApi(token) {
  const savedEndpoint =
    localStorage.getItem("app_settings_ep");

  const endpointOrder = [
    savedEndpoint,
    ...SETTINGS_ENDPOINT_CANDIDATES,
  ].filter(Boolean);

  const uniqueEndpoints = [...new Set(endpointOrder)];

  for (const endpoint of uniqueEndpoints) {
    try {
      const response = await fetch(
        `${API_BASE}/${endpoint}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        localStorage.setItem(
          "app_settings_ep",
          endpoint
        );

        return response;
      }
    } catch {
      // Diğer endpoint denenir.
    }
  }

  return null;
}

async function saveSettingsToApi(token, body) {
  const savedEndpoint =
    localStorage.getItem("app_settings_ep");

  const endpointOrder = [
    savedEndpoint,
    ...SETTINGS_ENDPOINT_CANDIDATES,
  ].filter(Boolean);

  const uniqueEndpoints = [...new Set(endpointOrder)];

  let lastResponse = null;

  for (const endpoint of uniqueEndpoints) {
    try {
      const response = await fetch(
        `${API_BASE}/${endpoint}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(body),
        }
      );

      lastResponse = response;

      if (response.ok) {
        localStorage.setItem(
          "app_settings_ep",
          endpoint
        );

        return response;
      }

      if (response.status !== 404) {
        return response;
      }
    } catch {
      // Diğer endpoint denenir.
    }
  }

  return lastResponse;
}

async function readFlagEndpoint(
  url,
  token,
  resolver
) {
  try {
    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) return null;

    const json = await response
      .json()
      .catch(() => ({}));

    return resolver(json);
  } catch {
    return null;
  }
}

async function updateFlagEndpoint(
  url,
  token,
  body
) {
  try {
    return await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });
  } catch (error) {
    console.error(
      "Modül ayarı kaydedilemedi:",
      url,
      error
    );

    return null;
  }
}

/* ===========================================================
   KÜÇÜK UI BİLEŞENLERİ
   =========================================================== */

function LanguageSegment({
  value,
  onChange,
}) {
  return (
    <div className="inline-flex overflow-hidden rounded-2xl border border-white/20 bg-white/10 p-1 backdrop-blur">
      {LANGUAGES.map((language) => {
        const active = value === language.code;

        return (
          <button
            key={language.code}
            type="button"
            onClick={() => onChange(language.code)}
            className={[
              "rounded-xl px-4 py-2 text-sm font-black transition",
              active
                ? "bg-white text-blue-700 shadow"
                : "text-white hover:bg-white/10",
            ].join(" ")}
          >
            {language.label}
          </button>
        );
      })}
    </div>
  );
}

function SectionHeader({
  icon,
  title,
  description,
  action,
}) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div className="flex min-w-0 items-start gap-3">
        <div className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-blue-600 to-orange-500 text-xl text-white shadow-lg shadow-blue-100">
          {icon}
        </div>

        <div className="min-w-0">
          <h2 className="break-words text-lg font-black tracking-tight text-slate-900 sm:text-xl">
            {title}
          </h2>

          {description && (
            <p className="mt-1 break-words text-sm leading-6 text-slate-500">
              {description}
            </p>
          )}
        </div>
      </div>

      {action}
    </div>
  );
}

function Field({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  className = "",
}) {
  return (
    <label className={`block min-w-0 ${className}`}>
      <span className="mb-1.5 block text-sm font-extrabold text-slate-700">
        {label}
      </span>

      <input
        type={type}
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full min-w-0 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-[15px] text-slate-900 outline-none transition placeholder:text-slate-400 hover:border-slate-300 focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
      />
    </label>
  );
}

function Toggle({
  checked,
  onChange,
  title,
  description,
}) {
  return (
    <label className="group flex cursor-pointer items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-slate-50/80 p-4 transition hover:border-blue-200 hover:bg-blue-50/50">
      <div className="min-w-0">
        <div className="break-words font-extrabold text-slate-900">
          {title}
        </div>

        {description && (
          <div className="mt-1 break-words text-sm leading-5 text-slate-500">
            {description}
          </div>
        )}
      </div>

      <span className="relative inline-flex h-7 w-12 shrink-0 items-center">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className="peer sr-only"
        />

        <span className="absolute inset-0 rounded-full bg-slate-300 transition peer-checked:bg-gradient-to-r peer-checked:from-blue-600 peer-checked:to-orange-500 peer-focus:ring-4 peer-focus:ring-blue-100" />

        <span className="absolute left-1 h-5 w-5 rounded-full bg-white shadow transition-transform peer-checked:translate-x-5" />
      </span>
    </label>
  );
}

/* ===========================================================
   SAYFA
   =========================================================== */

export default function AyarlarPage() {
  const initialUiLanguage =
    localStorage.getItem("app_lang") ||
    localStorage.getItem("lang") ||
    "tr";

  const [uiLanguage, setUiLanguage] =
    useState(
      ["tr", "en", "de"].includes(
        initialUiLanguage
      )
        ? initialUiLanguage
        : "tr"
    );

  const copy =
    TEXTS[uiLanguage] || TEXTS.tr;

  const [contentLanguage, setContentLanguage] =
    useState("tr");

  const [
    activeContentLanguages,
    setActiveContentLanguages,
  ] = useState(["tr"]);

  const [
    companyNameByLanguage,
    setCompanyNameByLanguage,
  ] = useState({
    tr: "",
    en: "",
    de: "",
  });

  const [
    sloganByLanguage,
    setSloganByLanguage,
  ] = useState({
    tr: "",
    en: "",
    de: "",
  });

  const [branchName, setBranchName] =
    useState("");

  const [authorizedName, setAuthorizedName] =
    useState("");

  const [city, setCity] =
    useState("");

  const [district, setDistrict] =
    useState("");

  const [phone, setPhone] =
    useState("");

  const [email, setEmail] =
    useState("");

  const [website, setWebsite] =
    useState("");

  const [facebook, setFacebook] =
    useState("");

  const [instagram, setInstagram] =
    useState("");

  const [twitter, setTwitter] =
    useState("");

  const [linkedin, setLinkedin] =
    useState("");

  const [youtube, setYoutube] =
    useState("");

  const [theme, setTheme] =
    useState("light");

  const [logo, setLogo] =
    useState("");

  const [logoVersion, setLogoVersion] =
    useState(0);

  const [menuEnabled, setMenuEnabled] =
    useState(false);

  const [
    allergensEnabled,
    setAllergensEnabled,
  ] = useState(false);

  const [
    visibleMenuItems,
    setVisibleMenuItems,
  ] = useState(DEFAULT_VISIBLE_MENU_ITEMS);

  const [menuSearch, setMenuSearch] =
    useState("");

  const [
    marketplaceVisibility,
    setMarketplaceVisibility,
  ] = useState("all");

  const [downloads, setDownloads] =
    useState([]);

  const [
    downloadDraft,
    setDownloadDraft,
  ] = useState({
    title: {
      tr: "",
      en: "",
      de: "",
    },
    description: {
      tr: "",
      en: "",
      de: "",
    },
    file: "",
    link: "",
  });

  const [
    editingDownloadId,
    setEditingDownloadId,
  ] = useState(null);

  const [
    sendingDownloadId,
    setSendingDownloadId,
  ] = useState(null);

  const [passwordOpen, setPasswordOpen] =
    useState(false);

  const [
    currentPassword,
    setCurrentPassword,
  ] = useState("");

  const [newPassword, setNewPassword] =
    useState("");

  const [
    newPasswordAgain,
    setNewPasswordAgain,
  ] = useState("");

  const [
    passwordLoading,
    setPasswordLoading,
  ] = useState(false);

  const [
    authorizationOpen,
    setAuthorizationOpen,
  ] = useState(true);

  const [authUsers, setAuthUsers] =
    useState([]);

  const [authDraft, setAuthDraft] =
    useState(createAuthDraft);

  const [
    editingAuthUserId,
    setEditingAuthUserId,
  ] = useState(null);

  const [
    openPermissionGroup,
    setOpenPermissionGroup,
  ] = useState(null);

  const [isSaving, setIsSaving] =
    useState(false);

  const [pageLoading, setPageLoading] =
    useState(true);

  const [notice, setNotice] =
    useState(null);

  const logoPreview = useMemo(() => {
    if (!logo) return "";

    const normalizedLogo =
      normalizeUploadUrl(logo);

    try {
      const absoluteUrl = normalizedLogo.startsWith(
        "http"
      )
        ? normalizedLogo
        : new URL(
            normalizedLogo,
            originWithoutPanel(ORIGIN)
          ).href;

      return `${absoluteUrl}${
        absoluteUrl.includes("?") ? "&" : "?"
      }v=${logoVersion}`;
    } catch {
      return normalizedLogo;
    }
  }, [logo, logoVersion]);

  const activeLanguageOptions =
    useMemo(
      () =>
        LANGUAGES.filter((language) =>
          activeContentLanguages.includes(
            language.code
          )
        ),
      [activeContentLanguages]
    );

  const filteredMenuItems = useMemo(() => {
    const locale =
      uiLanguage === "tr"
        ? "tr-TR"
        : undefined;

    const searchValue = menuSearch
      .trim()
      .toLocaleLowerCase(locale);

    if (!searchValue) {
      return PANEL_MENU_ITEMS;
    }

    return PANEL_MENU_ITEMS.filter(
      (menuItem) => {
        const label =
          menuItem.labels?.[uiLanguage] ||
          menuItem.labels?.tr ||
          menuItem.key;

        const description =
          menuItem.descriptions?.[
            uiLanguage
          ] ||
          menuItem.descriptions?.tr ||
          "";

        const haystack =
          `${label} ${description} ${menuItem.key}`.toLocaleLowerCase(
            locale
          );

        return haystack.includes(searchValue);
      }
    );
  }, [menuSearch, uiLanguage]);

  const profileCompletion = useMemo(() => {
    const values = [
      companyNameByLanguage.tr ||
        companyNameByLanguage.en ||
        companyNameByLanguage.de,
      authorizedName,
      phone,
      email,
      city,
      district,
      logo,
      website,
    ];

    const filledCount = values.filter(
      (value) =>
        String(value || "").trim().length > 0
    ).length;

    return Math.round(
      (filledCount / values.length) * 100
    );
  }, [
    companyNameByLanguage,
    authorizedName,
    phone,
    email,
    city,
    district,
    logo,
    website,
  ]);

  function showNotice(type, message) {
    setNotice({
      type,
      message,
    });

    window.setTimeout(() => {
      setNotice(null);
    }, 3500);
  }

  function changeUiLanguage(languageCode) {
    setUiLanguage(languageCode);

    localStorage.setItem(
      "panel_dili",
      languageCode
    );

    localStorage.setItem(
      "app_lang",
      languageCode
    );

    localStorage.setItem(
      "lang",
      languageCode
    );

    try {
      const languageMap = JSON.parse(
        localStorage.getItem(
          "app_institution_by_lang"
        ) || "{}"
      );

      localStorage.setItem(
        "app_institution_name",
        languageMap?.[languageCode] ||
          languageMap?.tr ||
          ""
      );
    } catch {
      // Hatalı localStorage değeri dikkate alınmaz.
    }

    window.dispatchEvent(
      new Event("app_lang_change")
    );

    window.dispatchEvent(
      new Event("app_settings_change")
    );
  }

  function toggleContentLanguage(languageCode) {
    setActiveContentLanguages(
      (previousLanguages) => {
        if (
          !previousLanguages.includes(
            languageCode
          )
        ) {
          return [
            ...previousLanguages,
            languageCode,
          ];
        }

        if (previousLanguages.length === 1) {
          return previousLanguages;
        }

        const nextLanguages =
          previousLanguages.filter(
            (code) => code !== languageCode
          );

        if (
          contentLanguage === languageCode
        ) {
          setContentLanguage(
            nextLanguages[0] || "tr"
          );
        }

        return nextLanguages;
      }
    );
  }

  function syncMenuRelatedStates(
    menuKey,
    enabled
  ) {
    if (menuKey === "marketplace") {
      setMarketplaceVisibility(
        (previousValue) => {
          if (!enabled) return "none";

          return previousValue === "none"
            ? "all"
            : previousValue;
        }
      );
    }
  }

  function toggleMenuItem(menuKey) {
    setVisibleMenuItems(
      (previousItems) => {
        const willEnable =
          !previousItems.includes(menuKey);

        syncMenuRelatedStates(
          menuKey,
          willEnable
        );

        if (willEnable) {
          return [
            ...previousItems,
            menuKey,
          ];
        }

        return previousItems.filter(
          (item) => item !== menuKey
        );
      }
    );
  }

  function enableAllMenus() {
    setVisibleMenuItems([
      ...DEFAULT_VISIBLE_MENU_ITEMS,
    ]);

    setMarketplaceVisibility(
      (previousValue) =>
        previousValue === "none"
          ? "all"
          : previousValue
    );
  }

  function disableAllMenus() {
    setVisibleMenuItems([]);
    setMarketplaceVisibility("none");
  }

  function resetDownloadDraft() {
    setEditingDownloadId(null);

    setDownloadDraft({
      title: {
        tr: "",
        en: "",
        de: "",
      },
      description: {
        tr: "",
        en: "",
        de: "",
      },
      file: "",
      link: "",
    });
  }

  function saveDownloadDraft() {
    const hasTitle =
      Object.values(
        downloadDraft.title || {}
      ).some(
        (value) =>
          String(value || "").trim() !== ""
      );

    if (
      !hasTitle &&
      !downloadDraft.file &&
      !downloadDraft.link
    ) {
      return;
    }

    if (editingDownloadId !== null) {
      setDownloads((previousDownloads) =>
        previousDownloads.map((download) =>
          download.id === editingDownloadId
            ? {
                ...download,
                title: {
                  ...(download.title || {}),
                  ...downloadDraft.title,
                },
                description: {
                  ...(download.description ||
                    {}),
                  ...downloadDraft.description,
                },
                file: downloadDraft.file,
                link: downloadDraft.link,
              }
            : download
        )
      );
    } else {
      setDownloads((previousDownloads) => [
        ...previousDownloads,
        {
          id: Date.now(),
          title: {
            ...downloadDraft.title,
          },
          description: {
            ...downloadDraft.description,
          },
          file: downloadDraft.file,
          link: downloadDraft.link,
        },
      ]);
    }

    resetDownloadDraft();
  }

  function editDownload(download) {
    setEditingDownloadId(download.id);

    setDownloadDraft({
      title: {
        tr: download?.title?.tr || "",
        en: download?.title?.en || "",
        de: download?.title?.de || "",
      },
      description: {
        tr:
          download?.description?.tr || "",
        en:
          download?.description?.en || "",
        de:
          download?.description?.de || "",
      },
      file: download?.file || "",
      link: download?.link || "",
    });

    document
      .getElementById("downloads-settings")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }

  function deleteDownload(downloadId) {
    setDownloads((previousDownloads) =>
      previousDownloads.filter(
        (download) =>
          download.id !== downloadId
      )
    );

    if (
      editingDownloadId === downloadId
    ) {
      resetDownloadDraft();
    }
  }

  async function sendDownload(download) {
    if (
      sendingDownloadId !== null
    ) {
      return;
    }

    const token =
      localStorage.getItem("token");

    if (!token) {
      showNotice(
        "error",
        copy.sessionNotFound
      );

      return;
    }

    let kurumId = Number(
      localStorage.getItem("kurum_id") ||
        localStorage.getItem("kurumId") ||
        0
    );

    if (!kurumId) {
      try {
        const tokenPart =
          token.split(".")[1] || "";

        const normalizedToken =
          tokenPart
            .replace(/-/g, "+")
            .replace(/_/g, "/");

        const paddedToken =
          normalizedToken.padEnd(
            Math.ceil(
              normalizedToken.length / 4
            ) * 4,
            "="
          );

        const tokenData = JSON.parse(
          atob(paddedToken)
        );

        kurumId = Number(
          tokenData?.kurum_id ||
            tokenData?.kurumId ||
            0
        );
      } catch {
        kurumId = 0;
      }
    }

    if (!kurumId) {
      showNotice(
        "error",
        copy.downloadSendFailed
      );

      return;
    }

    const title =
      download?.title?.[
        contentLanguage
      ] ||
      download?.title?.tr ||
      download?.title?.en ||
      download?.title?.de ||
      copy.untitled;

    const description =
      download?.description?.[
        contentLanguage
      ] ||
      download?.description?.tr ||
      download?.description?.en ||
      download?.description?.de ||
      "";

    const defaultMessages = {
      tr:
        "Yeni bir dosya veya bağlantı paylaşıldı. Görüntülemek için uygulamadaki Evraklarım bölümünü açın.",
      en:
        "A new file or link has been shared. Open My Documents in the application to view it.",
      de:
        "Eine neue Datei oder ein Link wurde geteilt. Öffnen Sie Meine Dokumente in der Anwendung.",
    };

    setSendingDownloadId(
      download.id
    );

    try {
      const saveResponse = await fetch(
        `${API_BASE}/kurum-downloads`,
        {
          method: "POST",
          headers: authHeaders(token),
          body: JSON.stringify({
            downloads,
          }),
        }
      );

      if (!saveResponse.ok) {
        throw new Error(
          "Dosya kaydedilemedi"
        );
      }

      const notificationResponse =
        await fetch(
          `${API_BASE}/test-notification`,
          {
            method: "POST",
            headers: authHeaders(token),
            body: JSON.stringify({
              kurum_id: kurumId,
              kaynak_tipi: "dosya",
              language:
                contentLanguage || "tr",
              baslik: title,
              mesaj:
                description ||
                defaultMessages[
                  contentLanguage
                ] ||
                defaultMessages.tr,
            }),
          }
        );

      if (!notificationResponse.ok) {
        throw new Error(
          "Bildirim gönderilemedi"
        );
      }

      showNotice(
        "success",
        copy.downloadSent
      );
    } catch (error) {
      console.error(
        "Dosya bildirimi gönderilemedi:",
        error
      );

      showNotice(
        "error",
        copy.downloadSendFailed
      );
    } finally {
      setSendingDownloadId(null);
    }
  }

  async function loadAuthUsers(
    providedToken
  ) {
    const token =
      providedToken ||
      localStorage.getItem("token");

    if (!token) return;

    try {
      const response = await fetch(
        AUTH_USERS_ENDPOINT,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const json = await response
        .json()
        .catch(() => ({}));

      if (!response.ok) {
        console.error(
          "Yetki kullanıcıları alınamadı:",
          json
        );

        return;
      }

      const userList = Array.isArray(
        json?.data
      )
        ? json.data
        : [];

      setAuthUsers(
        userList.map(normalizeAuthUser)
      );
    } catch (error) {
      console.error(
        "Yetki kullanıcıları yüklenemedi:",
        error
      );
    }
  }

  function resetAuthDraft() {
    setEditingAuthUserId(null);
    setAuthDraft(createAuthDraft());
  }

  function changeAuthRole(roleKey) {
    const selectedPreset =
      ROLE_PRESETS[roleKey] ||
      ROLE_PRESETS.custom;

    setAuthDraft((previousDraft) => ({
      ...previousDraft,
      role: roleKey,
      permissions: createPermissionMap(
        selectedPreset.permissions || []
      ),
    }));
  }

  function togglePermission(
    permissionKey
  ) {
    setAuthDraft((previousDraft) => ({
      ...previousDraft,
      role: "custom",
      permissions: {
        ...createPermissionMap(),
        ...(previousDraft.permissions || {}),
        [permissionKey]:
          !previousDraft.permissions?.[
            permissionKey
          ],
      },
    }));
  }

  function togglePermissionGroup(
    permissionGroup,
    checked
  ) {
    setAuthDraft((previousDraft) => {
      const nextPermissions = {
        ...createPermissionMap(),
        ...(previousDraft.permissions || {}),
      };

      permissionGroup.items.forEach(
        (permissionItem) => {
          nextPermissions[
            permissionItem.key
          ] = checked;
        }
      );

      return {
        ...previousDraft,
        role: "custom",
        permissions: nextPermissions,
      };
    });
  }

  function toggleAllPermissions(checked) {
    setAuthDraft((previousDraft) => ({
      ...previousDraft,
      role: checked ? "owner" : "custom",
      permissions: createPermissionMap(
        checked
          ? ALL_PERMISSION_KEYS
          : []
      ),
    }));
  }

  async function saveAuthUser() {
    const token =
      localStorage.getItem("token");

    if (!token) {
      showNotice(
        "error",
        copy.sessionNotFound
      );

      return;
    }

    const name =
      authDraft.name.trim();

    const username =
      authDraft.username.trim();

    const password =
      authDraft.password.trim();

    if (!name || !username) {
      showNotice(
        "error",
        "Ad soyad ve kullanıcı maili zorunludur."
      );

      return;
    }

    if (
      !editingAuthUserId &&
      password.length < 6
    ) {
      showNotice(
        "error",
        "Yeni kullanıcı şifresi en az 6 karakter olmalıdır."
      );

      return;
    }

    if (
      editingAuthUserId &&
      password &&
      password.length < 6
    ) {
      showNotice(
        "error",
        copy.passwordMin
      );

      return;
    }

    const body = {
      name,
      username,
      role: authDraft.role || "custom",
      active: authDraft.active === true,
      branchScope:
        authDraft.branchScope || "all",
      branchName:
        authDraft.branchName.trim(),
      notes: authDraft.notes.trim(),
      permissions: {
        ...createPermissionMap(),
        ...(authDraft.permissions || {}),
      },
    };

    if (!editingAuthUserId) {
      body.password = password;
    }

    try {
      const endpoint = editingAuthUserId
        ? `${AUTH_USERS_ENDPOINT}/${editingAuthUserId}`
        : AUTH_USERS_ENDPOINT;

      const response = await fetch(endpoint, {
        method: editingAuthUserId
          ? "PUT"
          : "POST",
        headers: authHeaders(token),
        body: JSON.stringify(body),
      });

      const json = await response
        .json()
        .catch(() => ({}));

      if (!response.ok) {
        showNotice(
          "error",
          json?.error ||
            "Kullanıcı kaydedilemedi."
        );

        return;
      }

      if (
        editingAuthUserId &&
        password
      ) {
        const passwordResponse =
          await fetch(
            `${AUTH_USERS_ENDPOINT}/${editingAuthUserId}/password`,
            {
              method: "PATCH",
              headers: authHeaders(token),
              body: JSON.stringify({
                password,
              }),
            }
          );

        const passwordJson =
          await passwordResponse
            .json()
            .catch(() => ({}));

        if (!passwordResponse.ok) {
          showNotice(
            "error",
            passwordJson?.error ||
              "Kullanıcı güncellendi fakat şifre değiştirilemedi."
          );

          return;
        }
      }

      await loadAuthUsers(token);
      resetAuthDraft();

      showNotice(
        "success",
        editingAuthUserId
          ? "Kullanıcı güncellendi."
          : "Kullanıcı oluşturuldu."
      );
    } catch (error) {
      console.error(
        "Kullanıcı kayıt hatası:",
        error
      );

      showNotice(
        "error",
        copy.serverError
      );
    }
  }

  function editAuthUser(user) {
    setEditingAuthUserId(user.id);

    setAuthDraft({
      ...createAuthDraft(),
      ...user,
      password: "",
      permissions: {
        ...createPermissionMap(),
        ...(user.permissions || {}),
      },
    });

    document
      .getElementById("users-settings")
      ?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }

  async function toggleAuthUserActive(
    user
  ) {
    const token =
      localStorage.getItem("token");

    if (!token) {
      showNotice(
        "error",
        copy.sessionNotFound
      );

      return;
    }

    try {
      const response = await fetch(
        `${AUTH_USERS_ENDPOINT}/${user.id}`,
        {
          method: "PUT",
          headers: authHeaders(token),
          body: JSON.stringify({
            name: user.name,
            username: user.username,
            role: user.role || "custom",
            active: !user.active,
            branchScope:
              user.branchScope || "all",
            branchName:
              user.branchName || "",
            notes: user.notes || "",
            permissions: {
              ...createPermissionMap(),
              ...(user.permissions || {}),
            },
          }),
        }
      );

      const json = await response
        .json()
        .catch(() => ({}));

      if (!response.ok) {
        showNotice(
          "error",
          json?.error ||
            "Kullanıcı durumu değiştirilemedi."
        );

        return;
      }

      await loadAuthUsers(token);

      showNotice(
        "success",
        !user.active
          ? "Kullanıcı aktif yapıldı."
          : "Kullanıcı pasif yapıldı."
      );
    } catch (error) {
      console.error(
        "Kullanıcı durum hatası:",
        error
      );

      showNotice(
        "error",
        copy.serverError
      );
    }
  }

  async function deleteAuthUser(userId) {
    const confirmed = window.confirm(
      "Bu kullanıcıyı silmek istiyor musunuz?"
    );

    if (!confirmed) return;

    const token =
      localStorage.getItem("token");

    if (!token) {
      showNotice(
        "error",
        copy.sessionNotFound
      );

      return;
    }

    try {
      const response = await fetch(
        `${AUTH_USERS_ENDPOINT}/${userId}`,
        {
          method: "DELETE",
          headers: authHeaders(token),
        }
      );

      const json = await response
        .json()
        .catch(() => ({}));

      if (!response.ok) {
        showNotice(
          "error",
          json?.error ||
            "Kullanıcı silinemedi."
        );

        return;
      }

      if (
        editingAuthUserId === userId
      ) {
        resetAuthDraft();
      }

      await loadAuthUsers(token);

      showNotice(
        "success",
        "Kullanıcı silindi."
      );
    } catch (error) {
      console.error(
        "Kullanıcı silme hatası:",
        error
      );

      showNotice(
        "error",
        copy.serverError
      );
    }
  }

  async function changePassword() {
    if (passwordLoading) return;

    if (
      !currentPassword ||
      !newPassword ||
      !newPasswordAgain
    ) {
      showNotice(
        "error",
        copy.fillAllFields
      );

      return;
    }

    if (
      newPassword !== newPasswordAgain
    ) {
      showNotice(
        "error",
        copy.passwordsNotMatch
      );

      return;
    }

    if (newPassword.length < 6) {
      showNotice(
        "error",
        copy.passwordMin
      );

      return;
    }

    const token =
      localStorage.getItem("token");

    if (!token) {
      showNotice(
        "error",
        copy.sessionNotFound
      );

      return;
    }

    setPasswordLoading(true);

    try {
      const response = await fetch(
        `${API_BASE}/auth/change-password`,
        {
          method: "POST",
          headers: {
            "Content-Type":
              "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            currentPassword,
            newPassword,
          }),
        }
      );

      const json = await response
        .json()
        .catch(() => ({}));

      if (!response.ok) {
        showNotice(
          "error",
          json?.error ||
            copy.passwordUpdateFailed
        );

        return;
      }

      setCurrentPassword("");
      setNewPassword("");
      setNewPasswordAgain("");
      setPasswordOpen(false);

      showNotice(
        "success",
        copy.passwordUpdated
      );
    } catch (error) {
      console.error(
        "Şifre değiştirme hatası:",
        error
      );

      showNotice(
        "error",
        copy.serverError
      );
    } finally {
      setPasswordLoading(false);
    }
  }

  async function loadSettings() {
    const token =
      localStorage.getItem("token");

    if (!token) {
      setPageLoading(false);
      return;
    }

    setPageLoading(true);

    try {
      const response =
        await getSettingsFromApi(token);

      if (response?.ok) {
        const json = await response
          .json()
          .catch(() => ({}));

        const data = json?.data || json || {};

        const activeLanguages =
          Array.isArray(data.aktif_diller) &&
          data.aktif_diller.length > 0
            ? data.aktif_diller.filter(
                (code) =>
                  ["tr", "en", "de"].includes(
                    code
                  )
              )
            : ["tr"];

        const safeActiveLanguages =
          activeLanguages.length > 0
            ? activeLanguages
            : ["tr"];

        setActiveContentLanguages(
          safeActiveLanguages
        );

        setContentLanguage(
          safeActiveLanguages.includes(data.dil)
            ? data.dil
            : safeActiveLanguages[0]
        );

        setCompanyNameByLanguage({
          tr: data.firma_adi_tr || "",
          en: data.firma_adi_en || "",
          de: data.firma_adi_de || "",
        });

        setSloganByLanguage({
          tr: data.slogan_tr || "",
          en: data.slogan_en || "",
          de: data.slogan_de || "",
        });

        setBranchName(
          data.sube_adi || ""
        );

        setAuthorizedName(
          data.yetkili_adi || ""
        );

        setCity(data.il || "");
        setDistrict(data.ilce || "");
        setPhone(data.telefon || "");
        setEmail(data.email || "");
        setWebsite(data.website || "");
        setFacebook(data.facebook || "");
        setInstagram(data.instagram || "");
        setTwitter(data.twitter || "");
        setLinkedin(data.linkedin || "");
        setYoutube(data.youtube || "");

        setTheme(
          data.tema === "dark"
            ? "dark"
            : "light"
        );

        setLogo(
          normalizeUploadUrl(
            data.logo_url ||
              data.logo ||
              ""
          )
        );

        setLogoVersion(
          (previousVersion) =>
            previousVersion + 1
        );

        setMenuEnabled(
          data.menu_enabled === true ||
            data.menu_enabled === "true"
        );

        setAllergensEnabled(
          data.allergen_enabled === true ||
            data.allergen_enabled === "true"
        );

        setDownloads(
          Array.isArray(data.downloads)
            ? data.downloads
            : []
        );

        setMarketplaceVisibility(
          data.marketplace_visibility ||
            "all"
        );

        const apiVisibleMenus =
          data.visible_menu_items ??
          data.panel_visible_menu_items ??
          data.sidebar_menu_items;

        const localVisibleMenus =
          localStorage.getItem(
            "app_visible_menu_items"
          );

        const userSavedSelection =
          localStorage.getItem(
            USER_SAVED_MENU_KEY
          ) === "true";

        let selectedMenus =
          userSavedSelection &&
          localVisibleMenus !== null
            ? normalizeVisibleMenuItems(
                localVisibleMenus,
                []
              )
            : normalizeVisibleMenuItems(
                apiVisibleMenus
              );

        const businessMigrationDone =
          localStorage.getItem(
            BUSINESS_NETWORK_MIGRATION_KEY
          ) === "true";

        const phoneMigrationDone =
          localStorage.getItem(
            PHONE_ORDER_MIGRATION_KEY
          ) === "true";

        if (
          !userSavedSelection &&
          !businessMigrationDone &&
          !selectedMenus.includes(
            "businessNetwork"
          )
        ) {
          selectedMenus.push(
            "businessNetwork"
          );
        }

    if (
  !userSavedSelection &&
  !phoneMigrationDone &&
  !selectedMenus.includes(
    "TelefonSiparis"
  )
) {
  selectedMenus.push(
    "TelefonSiparis"
  );
}

/*
  Kullanıcı daha önce menü seçimini
  elle kaydetmediyse kurs modülü
  otomatik olarak açık gelir.
*/
if (
  !userSavedSelection &&
  !selectedMenus.includes(
    "coursePrograms"
  )
) {
  selectedMenus.push(
    "coursePrograms"
  );
}

selectedMenus =
  normalizeVisibleMenuItems(
    selectedMenus,
    DEFAULT_VISIBLE_MENU_ITEMS
  );




        setVisibleMenuItems(
          selectedMenus
        );

        localStorage.setItem(
          "app_visible_menu_items",
          JSON.stringify(selectedMenus)
        );
      }

      await loadAuthUsers(token);
    } catch (error) {
      console.error(
        "Ayarlar yüklenirken hata:",
        error
      );
    } finally {
      setPageLoading(false);
    }
  }

  async function saveSettings() {
    if (isSaving) return;

    const token =
      localStorage.getItem("token");

    if (!token) {
      showNotice(
        "error",
        copy.sessionNotFound
      );

      return;
    }

    setIsSaving(true);

    const cleanedVisibleMenus =
      normalizeVisibleMenuItems(
        visibleMenuItems,
        []
      );

    const moduleFlags = {
      orderTracking:
        cleanedVisibleMenus.includes(
          "orders"
        ),
      cemetery:
        cleanedVisibleMenus.includes(
          "cemetery"
        ),
      beauty:
        cleanedVisibleMenus.includes(
          "beauty"
        ),
      appointments:
        cleanedVisibleMenus.includes(
          "appointments"
        ),
      accounting:
        cleanedVisibleMenus.includes(
          "accounting"
        ),
      digitalSignature:
        cleanedVisibleMenus.includes(
          "digitalSignature"
        ),
    };

    const effectiveMarketplaceVisibility =
      cleanedVisibleMenus.includes(
        "marketplace"
      )
        ? marketplaceVisibility === "none"
          ? "all"
          : marketplaceVisibility
        : "none";

    const normalizedLogo =
      normalizeUploadUrl(logo);

    const cleanedDownloads =
      downloads.filter((download) => {
        const hasTitle =
          Object.values(
            download?.title || {}
          ).some(
            (value) =>
              String(value || "").trim()
                .length > 0
          );

        return (
          hasTitle ||
          download?.file ||
          download?.link
        );
      });

    const languagePayload = {};

    LANGUAGES.forEach((language) => {
      const languageIsActive =
        activeContentLanguages.includes(
          language.code
        );

      languagePayload[
        `firma_adi_${language.code}`
      ] = languageIsActive
        ? (
            companyNameByLanguage[
              language.code
            ] || ""
          ).trim()
        : "";

      languagePayload[
        `slogan_${language.code}`
      ] = languageIsActive
        ? (
            sloganByLanguage[
              language.code
            ] || ""
          ).trim()
        : "";
    });

    const body = {
      ...languagePayload,

      aktif_diller:
        activeContentLanguages.length > 0
          ? activeContentLanguages
          : ["tr"],

      dil: contentLanguage || "tr",
      panel_dili: uiLanguage || "tr",

      sube_adi: branchName.trim(),
      yetkili_adi: authorizedName.trim(),
      il: city.trim(),
      ilce: district.trim(),
      telefon: phone.trim(),
      email: email.trim(),
      website: website.trim(),

      facebook: facebook.trim(),
      instagram: instagram.trim(),
      twitter: twitter.trim(),
      linkedin: linkedin.trim(),
      youtube: youtube.trim(),

      tema: theme,
      logo: normalizedLogo,
      logo_url: normalizedLogo,

      menu_enabled: menuEnabled,
      allergen_enabled:
        allergensEnabled,

      booking_enabled:
        moduleFlags.appointments,

      accounting_enabled:
        moduleFlags.accounting,

      memorial_enabled:
        moduleFlags.cemetery,

      cemetery_enabled:
        moduleFlags.cemetery,

      beauty_enabled:
        moduleFlags.beauty,

      beaty_enabled:
        moduleFlags.beauty,

      marketplace_visibility:
        effectiveMarketplaceVisibility,

      visible_menu_items:
        cleanedVisibleMenus,

      panel_visible_menu_items:
        cleanedVisibleMenus,

      sidebar_menu_items:
        cleanedVisibleMenus,

      downloads: cleanedDownloads,
    };

    try {
      const response =
        await saveSettingsToApi(
          token,
          body
        );

      if (!response?.ok) {
        const json = await response
          ?.json()
          .catch(() => ({}));

        showNotice(
          "error",
          json?.error ||
            copy.saveFailed
        );

        return;
      }

      await Promise.all([
        updateFlagEndpoint(
          `${API_BASE}/menu/settings`,
          token,
          {
            siparis_takibi_aktif:
              moduleFlags.orderTracking,
          }
        ),

        updateFlagEndpoint(
          `${API_BASE}/randevu/settings`,
          token,
          {
            randevu_aktif:
              moduleFlags.appointments,
          }
        ),

        updateFlagEndpoint(
          `${API_BASE}/accounting/settings`,
          token,
          {
            accounting_aktif:
              moduleFlags.accounting,
          }
        ),

        updateFlagEndpoint(
          `${API_BASE}/dijitalimza/settings`,
          token,
          {
            dijital_imza_aktif:
              moduleFlags.digitalSignature,
          }
        ),

        updateFlagEndpoint(
          `${API_BASE}/cemetery/settings`,
          token,
          {
            cemetery_enabled:
              moduleFlags.cemetery,
            allow_public_condolences: true,
            require_approval: false,
            allow_public_gallery: true,
          }
        ),

        updateFlagEndpoint(
          `${API_BASE}/beaty/settings`,
          token,
          {
            beauty_enabled:
              moduleFlags.beauty,
            beaty_enabled:
              moduleFlags.beauty,
          }
        ),

        updateFlagEndpoint(
          `${API_BASE}/market/visibility`,
          token,
          {
            visibility:
              effectiveMarketplaceVisibility,
          }
        ),
      ]);

      localStorage.setItem(
        "content_lang",
        contentLanguage
      );

      localStorage.setItem(
        "panel_dili",
        uiLanguage
      );

      localStorage.setItem(
        "app_lang",
        uiLanguage
      );

      localStorage.setItem(
        "lang",
        uiLanguage
      );

      localStorage.setItem(
        "app_visible_menu_items",
        JSON.stringify(
          cleanedVisibleMenus
        )
      );

      localStorage.setItem(
        USER_SAVED_MENU_KEY,
        "true"
      );

      localStorage.setItem(
        BUSINESS_NETWORK_MIGRATION_KEY,
        "true"
      );

      localStorage.setItem(
        PHONE_ORDER_MIGRATION_KEY,
        "true"
      );

      localStorage.setItem(
        "app_business_network_menu_migrated",
        "true"
      );

      localStorage.setItem(
        "app_institution_by_lang",
        JSON.stringify(
          companyNameByLanguage
        )
      );

      localStorage.setItem(
        "app_institution_name",
        companyNameByLanguage[
          uiLanguage
        ] ||
          companyNameByLanguage[
            contentLanguage
          ] ||
          companyNameByLanguage.tr ||
          ""
      );

      localStorage.setItem(
        "app_authorized_name",
        authorizedName
      );

      localStorage.setItem(
        "app_logo_url",
        normalizedLogo ||
          "/logo192.png"
      );

      localStorage.setItem(
        "orderTrackingEnabled",
        moduleFlags.orderTracking
          ? "true"
          : "false"
      );

      window.dispatchEvent(
        new Event("app_lang_change")
      );

      window.dispatchEvent(
        new Event("app_settings_change")
      );

      showNotice(
        "success",
        copy.saved
      );
    } catch (error) {
      console.error(
        "Ayarlar kaydedilirken hata:",
        error
      );

      showNotice(
        "error",
        copy.serverError
      );
    } finally {
      setIsSaving(false);
    }
  }

  useEffect(() => {
    loadSettings();
  }, []);

 return (
  <div className="settings-page min-h-[100dvh] w-full max-w-full min-w-0 overflow-x-hidden bg-[radial-gradient(circle_at_top_left,_rgba(37,99,235,0.10),_transparent_34%),radial-gradient(circle_at_top_right,_rgba(249,115,22,0.12),_transparent_30%),#f8fafc]">

      <style>{`

/* =========================================================
   KULLANICI YETKİLERİ PROFESYONEL RESPONSIVE TASARIM
   930px altında Cari mobil görünümü mantığına geçer
   ========================================================= */

.permission-top-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.permission-select-button {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: 13px;
  padding: 9px 16px;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
  white-space: nowrap;
  transition:
    transform 180ms ease,
    box-shadow 180ms ease,
    background 180ms ease;
}

.permission-select-button:hover {
  transform: translateY(-1px);
}

.permission-select-button:active {
  transform: scale(0.98);
}

.permission-select-button-active {
  border: 1px solid #2563eb;
  background: linear-gradient(
    135deg,
    #2563eb,
    #1d4ed8
  );
  color: #ffffff;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.22);
}

.permission-select-button-passive {
  border: 1px solid #dbe3ef;
  background: #ffffff;
  color: #334155;
}

.permission-select-button-passive:hover {
  border-color: #cbd5e1;
  background: #f8fafc;
}

/* YETKİ GRUP KARTI */

.permission-group-card {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  border: 1px solid #dbe3ef;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);
  transition:
    border-color 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
}

.permission-group-card:hover {
  border-color: #bfdbfe;
  box-shadow: 0 9px 24px rgba(37, 99, 235, 0.08);
}

.permission-group-card-open {
  border-color: #93c5fd;
  box-shadow: 0 12px 28px rgba(37, 99, 235, 0.1);
}

.permission-group-card-selected {
  border-left: 4px solid #f97316;
}

.permission-group-head {
  display: grid;
  grid-template-columns:
    minmax(0, 1fr)
    auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-items: stretch;
  background: linear-gradient(
    135deg,
    #f8fafc,
    #f1f5f9
  );
}

.permission-group-main {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border: 0;
  background: transparent;
  padding: 14px 16px;
  text-align: left;
  cursor: pointer;
}

.permission-group-main:hover {
  background: linear-gradient(
    135deg,
    rgba(239, 246, 255, 0.9),
    rgba(255, 247, 237, 0.7)
  );
}

.permission-group-info {
  min-width: 0;
  flex: 1;
}

.permission-group-title-row {
  display: flex;
  min-width: 0;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.permission-group-icon {
  display: inline-grid;
  width: 31px;
  height: 31px;
  flex: 0 0 31px;
  place-items: center;
  border-radius: 10px;
  background: linear-gradient(
    135deg,
    #dbeafe,
    #ffedd5
  );
  font-size: 15px;
}

.permission-group-title {
  min-width: 0;
  color: #0f172a;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.permission-count-badge {
  display: inline-flex;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #e2e8f0;
  padding: 3px 9px;
  color: #64748b;
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
}

.permission-count-badge-active {
  background: #ffedd5;
  color: #c2410c;
}

.permission-group-description {
  display: block;
  width: 100%;
  min-width: 0;
  margin-top: 6px;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.permission-toggle-circle {
  display: grid;
  width: 35px;
  height: 35px;
  flex: 0 0 35px;
  place-items: center;
  border: 1px solid #dbe3ef;
  border-radius: 999px;
  background: #ffffff;
  color: #475569;
  font-size: 20px;
  font-weight: 900;
  box-shadow: 0 3px 8px rgba(15, 23, 42, 0.06);
  transition:
    background 180ms ease,
    color 180ms ease,
    transform 180ms ease;
}

.permission-toggle-circle-open {
  border-color: #2563eb;
  background: #2563eb;
  color: #ffffff;
  transform: rotate(180deg);
}

/* TÜMÜ SEÇİMİ */

.permission-group-all {
  position: relative;
  display: flex;
  min-width: 105px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-left: 1px solid #dbe3ef;
  padding: 12px 15px;
  color: #475569;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
  cursor: pointer;
  user-select: none;
  transition:
    background 180ms ease,
    color 180ms ease;
}

.permission-group-all:hover {
  background: #eff6ff;
  color: #1d4ed8;
}

.permission-group-all input {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  opacity: 0;
  pointer-events: none;
}

.permission-custom-checkbox {
  display: grid;
  width: 23px;
  height: 23px;
  flex: 0 0 23px;
  place-items: center;
  border: 2px solid #94a3b8;
  border-radius: 7px;
  background: #ffffff;
  color: #ffffff;
  font-size: 14px;
  font-weight: 900;
}

.permission-group-all-checked {
  background: #eff6ff;
  color: #1d4ed8;
}

.permission-group-all-checked
  .permission-custom-checkbox {
  border-color: #2563eb;
  background: #2563eb;
}

.permission-group-all-partial
  .permission-custom-checkbox {
  border-color: #f97316;
  background: #f97316;
}

.permission-all-text {
  display: inline-block;
  white-space: nowrap;
  word-break: normal;
  writing-mode: horizontal-tb;
}

/* AÇILAN YETKİLER */

.permission-items-grid {
  display: grid;
  grid-template-columns:
    repeat(2, minmax(0, 1fr));
  width: 100%;
  max-width: 100%;
  min-width: 0;
  gap: 9px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 12px;
  animation: permissionOpen 180ms ease-out;
}

.permission-item-row {
  display: flex;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 13px;
  background: #ffffff;
  padding: 11px 12px;
  cursor: pointer;
  transition:
    border-color 180ms ease,
    background 180ms ease,
    transform 180ms ease;
}

.permission-item-row:hover {
  border-color: #fed7aa;
  background: #fff7ed;
  transform: translateY(-1px);
}

.permission-item-row-checked {
  border-color: #93c5fd;
  background: linear-gradient(
    135deg,
    #eff6ff,
    #fff7ed
  );
}

.permission-item-content {
  min-width: 0;
  flex: 1;
}

.permission-item-label {
  color: #0f172a;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.45;
  overflow-wrap: anywhere;
}

.permission-item-key {
  width: 100%;
  max-width: 100%;
  margin-top: 3px;
  overflow: hidden;
  color: #94a3b8;
  font-family: monospace;
  font-size: 10px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.permission-item-input {
  width: 19px !important;
  height: 19px !important;
  min-width: 19px !important;
  flex: 0 0 19px;
  accent-color: #f97316;
  cursor: pointer;
}

@keyframes permissionOpen {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =========================================================
   CARİ SAYFASINDAKİ GİBİ 930PX MOBİL GEÇİŞİ
   ========================================================= */

@media (max-width: 900px) {

  .permission-top-actions {
    display: grid;
    grid-template-columns:
      repeat(2, minmax(0, 1fr));
    width: 100%;
    max-width: 100%;
    gap: 8px;
  }

  .permission-select-button {
    width: 100%;
    min-width: 0;
    min-height: 44px;
    padding: 10px 8px;
    font-size: 12px;
  }

  .permission-group-card {
    border-radius: 17px;
  }

  .permission-group-head {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .permission-group-main {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 13px;
  }

  .permission-group-title-row {
    display: grid;
    grid-template-columns:
      31px
      minmax(0, 1fr)
      auto;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    align-items: center;
    gap: 8px;
  }

  .permission-group-title {
    width: 100%;
    min-width: 0;
    font-size: 13px;
    line-height: 1.4;
  }

  .permission-count-badge {
    font-size: 10px;
    padding: 3px 7px;
  }

  .permission-group-description {
    display: block;
    max-width: 100%;
    font-size: 11px;
    line-height: 1.45;
    white-space: normal;
    overflow: visible;
  }

  .permission-toggle-circle {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }

  .permission-group-all {
    width: calc(100% - 24px);
    min-width: 0;
    min-height: 44px;
    justify-content: flex-start;
    margin: 0 12px 12px;
    border: 1px solid #dbe3ef;
    border-radius: 12px;
    background: #ffffff;
    padding: 9px 12px;
    white-space: nowrap;
  }

  .permission-group-all-checked {
    border-color: #93c5fd;
    background: #eff6ff;
  }

  .permission-all-text {
    white-space: nowrap !important;
    word-break: keep-all !important;
    writing-mode: horizontal-tb !important;
  }

  .permission-items-grid {
    grid-template-columns:
      minmax(0, 1fr);
    gap: 8px;
    padding: 10px;
  }

  .permission-item-row {
    min-height: 58px;
    padding: 10px 11px;
  }

  .permission-item-label {
    font-size: 12px;
  }
}

/* ÇOK KÜÇÜK TELEFON */

@media (max-width: 430px) {
  .permission-top-actions {
    grid-template-columns:
      minmax(0, 1fr);
  }

  .permission-group-main {
    align-items: flex-start;
    gap: 9px;
  }

  .permission-group-title-row {
    grid-template-columns:
      29px
      minmax(0, 1fr);
  }

  .permission-count-badge {
    grid-column: 2;
    width: max-content;
  }

  .permission-toggle-circle {
    width: 31px;
    height: 31px;
    flex-basis: 31px;
    font-size: 18px;
  }

  .permission-group-all {
    width: calc(100% - 20px);
    margin: 0 10px 10px;
  }
}







        @keyframes settingsFloat {
          0%, 100% {
            transform: translateY(0px);
          }

          50% {
            transform: translateY(-7px);
          }
        }

        @keyframes settingsShine {
          0% {
            transform: translateX(-150%) skewX(-18deg);
          }

          55%, 100% {
            transform: translateX(260%) skewX(-18deg);
          }
        }

        @keyframes settingsSlideIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .settings-floating-icon {
          animation: settingsFloat 5s ease-in-out infinite;
        }

        .settings-hero-shine::after {
          content: "";
          position: absolute;
          top: -40%;
          bottom: -40%;
          left: -25%;
          width: 18%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255,255,255,.34),
            transparent
          );
          animation: settingsShine 5.5s ease-in-out infinite;
          pointer-events: none;
        }

        .settings-notice {
          animation: settingsSlideIn .25s ease-out;
        }

        .settings-scrollbar::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }

        .settings-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 999px;
        }

      .settings-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

/* =========================================================
   AYARLAR SAYFASI GENİŞLİK VE MOBİL DÜZELTMELERİ
   CariPage mantığıyla tam genişlik ve taşma koruması
   ========================================================= */

.settings-page,
.settings-page * {
  box-sizing: border-box;
}

.settings-page {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
}

.settings-content {
  width: 100%;
  max-width: none;
  min-width: 0;
  margin: 0;
  overflow-x: hidden;
}

.settings-content > *,
.settings-page section,
.settings-page article,
.settings-page form,
.settings-page label {
  max-width: 100%;
  min-width: 0;
}

.settings-page [class*="grid-cols-"] > *,
.settings-page [class*="flex"] > * {
  min-width: 0;
}

.settings-page input,
.settings-page select,
.settings-page textarea {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.settings-page button {
  max-width: 100%;
}

.settings-page img,
.settings-page video,
.settings-page iframe {
  max-width: 100%;
}

.settings-page h1,
.settings-page h2,
.settings-page h3,
.settings-page p {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: normal;
}

.settings-page span,
.settings-page strong,
.settings-page button,
.settings-page label {
  word-break: normal;
  overflow-wrap: normal;
}

.settings-page button,
.settings-page label,
.settings-page span,
.settings-page strong {
  word-break: normal;
}

.settings-page .permission-all-text {
  display: inline-block;
  white-space: nowrap !important;
  overflow-wrap: normal !important;
  word-break: keep-all !important;
  writing-mode: horizontal-tb !important;
}



.settings-page .settings-scrollbar {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.settings-page .settings-scrollbar > div {
  max-width: 100%;
}

/*
  Yalnızca Hızlı Erişim buton sırası
  kendi içinde yatay kayabilir.
*/

.settings-page
  .settings-quick-scroll
  > .settings-quick-row {
  width: max-content !important;
  min-width: max-content !important;
  max-width: none !important;
}


/* =========================================================
   AYARLAR PAGE RESPONSIVE FINAL
   Kasa sayfasındaki çalışan 900px mobil mantığı
   Sadece görünüm değişir; fonksiyonlara dokunmaz.
   ========================================================= */

@media (max-width: 900px) {
  html,
  body,
  #root {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden !important;
  }

  .settings-page {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: hidden !important;
  }

  .settings-content {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 8px !important;
    overflow-x: hidden !important;
  }

  .settings-content > *,
  .settings-content > section,
  .settings-page article,
  .settings-page form {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  /* ÜST BAŞLIK */

  .settings-hero-shine {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 15px !important;
    border-radius: 19px !important;
  }

  .settings-hero-shine
    > .relative.z-10.flex {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    gap: 14px !important;
  }

  .settings-hero-shine h1 {
    max-width: 100%;
    font-size: 26px !important;
    line-height: 1.15 !important;
    overflow-wrap: anywhere;
  }

  .settings-hero-shine p {
    max-width: 100%;
    font-size: 12px !important;
    line-height: 1.5 !important;
    overflow-wrap: anywhere;
  }

  /* DİL VE KAYDET ALANI */

  .settings-hero-actions {
    display: grid !important;
    grid-template-columns:
      repeat(2, minmax(0, 1fr)) !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    gap: 8px !important;
  }

  .settings-hero-actions > * {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .settings-hero-actions
    > .rounded-2xl {
    padding: 7px !important;
  }

  .settings-hero-actions
    .inline-flex {
    display: grid !important;
    grid-template-columns:
      repeat(3, minmax(0, 1fr)) !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .settings-hero-actions
    .inline-flex button {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 8px 5px !important;
    font-size: 12px !important;
  }

  .settings-hero-actions
    > button {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    min-height: 48px !important;
    padding: 10px !important;
    font-size: 13px !important;
  }

  /* ÜST ÖZET KARTLARI */

  .settings-summary-grid {
    display: grid !important;
    grid-template-columns:
      repeat(2, minmax(0, 1fr)) !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    gap: 9px !important;
    margin-top: 13px !important;
  }

  .settings-summary-grid > div {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 11px !important;
    border-radius: 15px !important;
  }

  .settings-summary-grid span,
  .settings-summary-grid strong,
  .settings-summary-grid div {
    max-width: 100%;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  /* HIZLI ERİŞİM */

  .settings-quick-nav {
    position: relative !important;
    top: auto !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-top: 9px !important;
    padding: 6px !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    border-radius: 15px !important;
    -webkit-overflow-scrolling: touch;
  }

  .settings-quick-nav > div {
    display: flex !important;
    width: max-content !important;
    min-width: max-content !important;
    max-width: none !important;
    gap: 6px !important;
  }

  .settings-quick-nav button {
    flex: 0 0 auto;
    min-height: 38px !important;
    padding: 8px 11px !important;
    font-size: 11px !important;
    white-space: nowrap !important;
    overflow-wrap: normal !important;
    word-break: keep-all !important;
  }

  /* ANA KARTLAR */

  .settings-content > section:not(.settings-quick-nav) {
    max-width: 100%;
    min-width: 0;
  }

  .settings-page section,
  .settings-page article {
    max-width: 100%;
    min-width: 0;
  }

  .settings-page input,
  .settings-page select,
  .settings-page textarea {
    display: block;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    font-size: 13px !important;
  }

  .settings-page textarea {
    resize: vertical;
  }

  .settings-page button {
    max-width: 100%;
  }

  .settings-page img,
  .settings-page video,
  .settings-page iframe {
    max-width: 100%;
  }

  /* KULLANICI VE YETKİLER */

  .settings-page #users-settings,
  .settings-page #security-settings,
  .settings-page #institution-settings {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .settings-page #users-settings > div,
  .settings-page #security-settings > div,
  .settings-page #institution-settings > div {
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .settings-page #users-settings button,
  .settings-page #security-settings button {
    min-width: 0;
  }

  .permission-top-actions {
    display: grid !important;
    grid-template-columns:
      repeat(2, minmax(0, 1fr)) !important;
    width: 100% !important;
    max-width: 100% !important;
    gap: 8px !important;
  }

  .permission-select-button {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    min-height: 43px !important;
    padding: 9px 7px !important;
    font-size: 12px !important;
  }

  .permission-group-card {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    border-radius: 16px;
  }

  .permission-group-head {
    display: flex !important;
    flex-direction: column !important;
    width: 100%;
    max-width: 100%;
    min-width: 0;
  }

  .permission-group-main {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 12px !important;
  }

  .permission-group-info,
  .permission-group-title-row,
  .permission-group-title,
  .permission-group-description {
    max-width: 100%;
    min-width: 0;
  }

  .permission-group-all {
    display: flex !important;
    width: calc(100% - 20px) !important;
    max-width: calc(100% - 20px) !important;
    min-width: 0 !important;
    min-height: 42px !important;
    justify-content: flex-start !important;
    margin: 0 10px 10px !important;
    padding: 8px 11px !important;
    border: 1px solid #dbe3ef !important;
    border-radius: 11px !important;
    white-space: nowrap !important;
  }

  .permission-all-text {
    display: inline-block !important;
    white-space: nowrap !important;
    overflow-wrap: normal !important;
    word-break: keep-all !important;
    writing-mode: horizontal-tb !important;
  }

  .permission-items-grid {
    display: grid !important;
    grid-template-columns:
      minmax(0, 1fr) !important;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    gap: 8px !important;
    padding: 9px !important;
  }

  .permission-item-row {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    min-height: 56px;
    padding: 9px 10px !important;
  }

  /* ALT SABİT KAYDET */

  .settings-content
    > .sticky.bottom-3 {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    bottom: 8px !important;
  }

  .settings-content
    > .sticky.bottom-3
    > div {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 10px !important;
    border-radius: 17px !important;
  }
}

/* =========================================================
   TELEFON
   ========================================================= */

@media (max-width: 560px) {
  .settings-content {
    padding: 7px !important;
  }

  .settings-hero-shine {
    padding: 13px !important;
    border-radius: 17px !important;
  }

  .settings-hero-shine h1 {
    font-size: 23px !important;
  }

  .settings-hero-actions {
    grid-template-columns:
      minmax(0, 1fr) !important;
  }

  .settings-summary-grid {
    grid-template-columns:
      repeat(2, minmax(0, 1fr)) !important;
    gap: 7px !important;
  }

  .settings-summary-grid > div {
    padding: 9px !important;
  }

  .settings-content
    > section:not(.settings-quick-nav) {
    border-radius: 17px !important;
  }

  .settings-page #users-settings > button,
  .settings-page #security-settings > button {
    width: 100%;
    min-width: 0;
    padding: 13px !important;
  }

  .settings-content
    > .sticky.bottom-3
    > div {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .settings-content
    > .sticky.bottom-3
    button {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }
}

/* =========================================================
   ÇOK KÜÇÜK TELEFON
   ========================================================= */

@media (max-width: 360px) {
  .settings-content {
    padding: 6px !important;
  }

  .settings-hero-shine {
    padding: 11px !important;
  }

  .settings-hero-shine h1 {
    font-size: 21px !important;
  }

  .settings-summary-grid {
    grid-template-columns:
      repeat(2, minmax(0, 1fr)) !important;
  }

  .settings-summary-grid > div {
    padding: 8px !important;
  }

  .permission-top-actions {
    grid-template-columns:
      minmax(0, 1fr) !important;
  }

  .permission-group-title-row {
    grid-template-columns:
      28px minmax(0, 1fr) !important;
  }

  .permission-count-badge {
    grid-column: 2;
    width: max-content;
  }
}



/* =========================================================
   HIZLI ERİŞİM - STOK SAYFASI SEKME MANTIĞI
   Dış kart taşmaz, butonlar içeride yatay kayar.
   ========================================================= */

.settings-quick-card {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid rgba(15, 23, 42, 0.1);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow:
    0 14px 35px
    rgba(15, 23, 42, 0.07);
  backdrop-filter: blur(14px);
}

.settings-quick-title {
  display: flex;
  min-width: 142px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-right: 1px solid #e2e8f0;
  background:
    linear-gradient(
      135deg,
      #0b4d8b,
      #1565c0
    );
  padding: 10px 14px;
  color: #ffffff;
}

.settings-quick-title-icon {
  display: grid;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  place-items: center;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.16);
  font-size: 15px;
}

.settings-quick-title-text {
  display: block;
  color: #ffffff;
  font-size: 12px;
  font-weight: 950;
  line-height: 1.2;
  white-space: nowrap !important;
  overflow-wrap: normal !important;
  word-break: keep-all !important;
}

.settings-quick-scroll {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 7px;
  scroll-behavior: smooth;
  scroll-snap-type: x proximity;
  overscroll-behavior-x: contain;
  -webkit-overflow-scrolling: touch;
}

.settings-quick-row {
  display: flex;
  width: max-content;
  min-width: max-content;
  align-items: stretch;
  gap: 7px;
}

.settings-quick-button {
  position: relative;
  display: inline-flex !important;
  width: auto !important;
  min-width: 132px !important;
  max-width: none !important;
  min-height: 52px;
  flex: 0 0 auto !important;
  align-items: center;
  justify-content: flex-start;
  gap: 9px;
  overflow: hidden;
  border: 1px solid #dbe3ef;
  border-radius: 14px;
  background:
    linear-gradient(
      180deg,
      #ffffff,
      #f8fafc
    );
  padding: 8px 12px;
  color: #334155;
  text-align: left;
  cursor: pointer;
  scroll-snap-align: start;
  box-shadow:
    0 4px 12px
    rgba(15, 23, 42, 0.04);
  transition:
    border-color 180ms ease,
    background 180ms ease,
    color 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;
}

.settings-quick-button::after {
  content: "";
  position: absolute;
  right: 12px;
  bottom: 0;
  left: 12px;
  height: 3px;
  border-radius: 999px 999px 0 0;
  background:
    linear-gradient(
      90deg,
      #0b4d8b,
      #f58220
    );
  opacity: 0;
  transform: scaleX(0.35);
  transition:
    opacity 180ms ease,
    transform 180ms ease;
}

.settings-quick-button:hover {
  border-color: #93c5fd;
  background:
    linear-gradient(
      135deg,
      #eff6ff,
      #fff7ed
    );
  color: #0b4d8b;
  box-shadow:
    0 8px 20px
    rgba(11, 77, 139, 0.1);
  transform: translateY(-1px);
}

.settings-quick-button:hover::after {
  opacity: 1;
  transform: scaleX(1);
}

.settings-quick-button:active {
  transform: scale(0.98);
}

.settings-quick-button-icon {
  display: grid;
  width: 34px;
  height: 34px;
  min-width: 34px;
  flex: 0 0 34px;
  place-items: center;
  border-radius: 11px;
  background:
    linear-gradient(
      135deg,
      #dbeafe,
      #ffedd5
    );
  font-size: 16px;
  line-height: 1;
}

.settings-quick-button-text {
  display: block;
  min-width: 0;
  color: inherit;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.25;
  white-space: nowrap !important;
  overflow-wrap: normal !important;
  word-break: keep-all !important;
  writing-mode: horizontal-tb !important;
}

/*
  Butona tıklanınca bölüm üst menünün
  altında kaybolmasın.
*/

.settings-page
  #institution-settings,
.settings-page
  #panel-menu-settings,
.settings-page
  #downloads-settings,
.settings-page
  #security-settings,
.settings-page
  #users-settings {
  scroll-margin-top: 18px;
}

/* =========================================================
   TABLET VE MOBİL
   Stok sekmelerindeki gibi yatay butonlar
   ========================================================= */

@media (max-width: 900px) {
  .settings-quick-card {
    display: block;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin-top: 10px;
    overflow: hidden !important;
    border-radius: 17px;
  }

  .settings-quick-title {
    width: 100%;
    min-width: 0;
    min-height: 42px;
    justify-content: flex-start;
    border-right: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    padding: 7px 10px;
  }

  .settings-quick-title-icon {
    width: 28px;
    height: 28px;
    flex-basis: 28px;
    border-radius: 9px;
    font-size: 14px;
  }

  .settings-quick-title-text {
    font-size: 11px;
  }

  .settings-quick-scroll {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 6px !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
  }

  .settings-quick-row {
    display: flex !important;
    width: max-content !important;
    min-width: max-content !important;
    max-width: none !important;
    gap: 6px !important;
  }

  .settings-quick-button {
    display: inline-flex !important;
    width: auto !important;
    min-width: 116px !important;
    max-width: none !important;
    min-height: 50px !important;
    flex: 0 0 116px !important;
    gap: 7px !important;
    padding: 7px 9px !important;
    border-radius: 13px !important;
  }

  .settings-quick-button-icon {
    width: 31px;
    height: 31px;
    min-width: 31px;
    flex-basis: 31px;
    border-radius: 10px;
    font-size: 15px;
  }

  .settings-quick-button-text {
    font-size: 11px !important;
    white-space: nowrap !important;
    overflow-wrap: normal !important;
    word-break: keep-all !important;
  }

  /*
    Önceki genel mobil kurallarındaki
    width:100% etkisini bu butonlarda kaldırır.
  */

  .settings-page
    .settings-quick-button {
    width: auto !important;
    max-width: none !important;
    min-width: 116px !important;
  }
}

/* NORMAL TELEFON */

@media (max-width: 560px) {
  .settings-quick-card {
    border-radius: 15px;
  }

  .settings-quick-title {
    min-height: 40px;
  }

  .settings-quick-button {
    min-width: 108px !important;
    flex-basis: 108px !important;
    min-height: 48px !important;
    padding: 6px 8px !important;
  }

  .settings-page
    .settings-quick-button {
    min-width: 108px !important;
  }

  .settings-quick-button-icon {
    width: 29px;
    height: 29px;
    min-width: 29px;
    flex-basis: 29px;
    font-size: 14px;
  }

  .settings-quick-button-text {
    font-size: 10px !important;
  }
}

/* ÇOK KÜÇÜK TELEFON */

@media (max-width: 360px) {
  .settings-quick-button {
    min-width: 102px !important;
    flex-basis: 102px !important;
  }

  .settings-page
    .settings-quick-button {
    min-width: 102px !important;
  }
}


/* =========================================================
   AYARLAR MOBİL FINAL
   DIŞ SAYFA ASLA TAŞMAZ
   SADECE HIZLI ERİŞİM KENDİ İÇİNDE KAYAR
   ========================================================= */

@media (max-width: 900px) {
  html,
  body,
  #root {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: hidden !important;
  }

  .settings-page {
    width: 100% !important;
    max-width: 100vw !important;
    min-width: 0 !important;
    overflow-x: clip !important;
  }

  .settings-content {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    margin: 0 !important;
    padding: 8px !important;
    overflow-x: clip !important;
  }

  .settings-content > *,
  .settings-page section,
  .settings-page article,
  .settings-page form {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  /* HERO */

  .settings-hero-shine {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 16px !important;
    border-radius: 20px !important;
    overflow: hidden !important;
  }

  .settings-hero-shine
    > .relative.z-10.flex {
    display: flex !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 16px !important;
  }

  .settings-hero-shine
    > .relative.z-10.flex
    > div {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .settings-hero-shine h1 {
    width: 100%;
    max-width: 100%;
    font-size: 27px !important;
    line-height: 1.15 !important;
    white-space: normal !important;
    overflow-wrap: anywhere !important;
  }

  .settings-hero-shine p {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-top: 10px !important;
    overflow: visible !important;
    font-size: 13px !important;
    line-height: 1.55 !important;
    white-space: normal !important;
    text-overflow: clip !important;
    overflow-wrap: anywhere !important;
    word-break: normal !important;
  }

  /* ARAYÜZ DİLİ VE KAYDET */

  .settings-hero-actions {
    display: grid !important;
    grid-template-columns:
      minmax(0, 1fr) !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    gap: 10px !important;
  }

  .settings-hero-actions > * {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .settings-hero-actions
    .inline-flex {
    display: grid !important;
    grid-template-columns:
      repeat(3, minmax(0, 1fr)) !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .settings-hero-actions
    .inline-flex button {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 10px 5px !important;
    white-space: nowrap !important;
  }

  .settings-hero-actions
    > button {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    min-height: 54px !important;
    padding: 12px 10px !important;
    font-size: 15px !important;
    white-space: normal !important;
  }

  /* ÖZET KARTLARI */

  .settings-summary-grid {
    display: grid !important;
    grid-template-columns:
      minmax(0, 1fr) !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    gap: 9px !important;
    margin-top: 16px !important;
  }

  .settings-summary-grid > div {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    padding: 13px !important;
    border-radius: 16px !important;
  }

  .settings-summary-grid
    > div
    > div {
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .settings-summary-grid span,
  .settings-summary-grid strong {
    max-width: 100% !important;
    white-space: normal !important;
    overflow-wrap: anywhere !important;
    word-break: normal !important;
  }

  /* HIZLI ERİŞİM DIŞ KARTI */

  .settings-quick-card {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow: hidden !important;
    border-radius: 17px !important;
  }

  .settings-quick-title {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  /*
    Yatay kayma yalnızca bu alanın içinde.
  */

  .settings-quick-scroll {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    padding: 6px !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
  }

  .settings-quick-row {
    display: flex !important;
    width: max-content !important;
    min-width: max-content !important;
    max-width: none !important;
    align-items: stretch !important;
    gap: 6px !important;
  }

  .settings-quick-button {
    display: inline-flex !important;
    width: auto !important;
    max-width: none !important;
    min-width: 132px !important;
    flex: 0 0 132px !important;
    align-items: center !important;
    justify-content: flex-start !important;
    padding: 8px 10px !important;
    white-space: nowrap !important;
  }

  .settings-quick-button-text {
    display: block !important;
    white-space: nowrap !important;
    overflow-wrap: normal !important;
    word-break: keep-all !important;
  }

  /*
    Genel section kuralları Hızlı Erişim
    iç butonlarını genişletmesin.
  */

  .settings-page
    .settings-quick-scroll
    .settings-quick-button {
    width: auto !important;
    max-width: none !important;
    min-width: 132px !important;
  }

  /* DİĞER KART VE FORMLAR */

  .settings-page input,
  .settings-page select,
  .settings-page textarea {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }

  .settings-page img,
  .settings-page video,
  .settings-page iframe {
    max-width: 100% !important;
  }
}

/* TELEFON */

@media (max-width: 560px) {
  .settings-content {
    padding: 7px !important;
  }

  .settings-hero-shine {
    padding: 14px !important;
    border-radius: 18px !important;
  }

  .settings-hero-shine h1 {
    font-size: 25px !important;
  }

  .settings-summary-grid {
    grid-template-columns:
      minmax(0, 1fr) !important;
  }

  .settings-quick-button {
    min-width: 124px !important;
    flex-basis: 124px !important;
  }

  .settings-page
    .settings-quick-scroll
    .settings-quick-button {
    min-width: 124px !important;
  }
}

/* ÇOK KÜÇÜK TELEFON */

@media (max-width: 360px) {
  .settings-content {
    padding: 6px !important;
  }

  .settings-hero-shine {
    padding: 12px !important;
  }

  .settings-hero-shine h1 {
    font-size: 23px !important;
  }

  .settings-quick-button {
    min-width: 116px !important;
    flex-basis: 116px !important;
  }

  .settings-page
    .settings-quick-scroll
    .settings-quick-button {
    min-width: 116px !important;
  }
}

`}</style>


      {notice && (
        <div className="settings-notice fixed right-3 top-3 z-[100] w-[calc(100%-24px)] max-w-md sm:right-5 sm:top-5">
          <div
            className={[
              "flex items-start gap-3 rounded-2xl border p-4 shadow-2xl backdrop-blur",
              notice.type === "success"
                ? "border-emerald-200 bg-emerald-50/95 text-emerald-800"
                : "border-red-200 bg-red-50/95 text-red-800",
            ].join(" ")}
          >
            <div className="text-xl">
              {notice.type === "success"
                ? "✅"
                : "⚠️"}
            </div>

            <div className="min-w-0 flex-1 break-words text-sm font-bold leading-6">
              {notice.message}
            </div>

            <button
              type="button"
              onClick={() => setNotice(null)}
              className="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-white/70 font-black"
            >
              ×
            </button>
          </div>
        </div>
      )}

<div className="settings-content w-full max-w-none min-w-0 px-3 py-4 sm:px-5 lg:px-6 lg:py-7">
        {/* HERO */}

        <section className="settings-hero-shine relative overflow-hidden rounded-[28px] bg-gradient-to-br from-slate-950 via-blue-950 to-slate-900 p-5 text-white shadow-2xl shadow-blue-200/40 sm:p-7 lg:p-9">
          <div className="absolute -right-16 -top-20 h-64 w-64 rounded-full bg-orange-500/20 blur-3xl" />
          <div className="absolute -bottom-24 left-1/3 h-64 w-64 rounded-full bg-blue-500/20 blur-3xl" />

          <div className="relative z-10 flex flex-col gap-6 xl:flex-row xl:items-center xl:justify-between">
            <div className="min-w-0">
              <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1.5 text-xs font-extrabold uppercase tracking-[0.18em] text-blue-100 backdrop-blur">
                <span className="h-2 w-2 animate-pulse rounded-full bg-orange-400" />

                MesYat Dijital Yönetim Merkezi
              </div>

              <div className="flex items-start gap-4">
                <div className="settings-floating-icon hidden h-16 w-16 shrink-0 place-items-center rounded-3xl bg-gradient-to-br from-blue-500 to-orange-500 text-3xl shadow-xl shadow-orange-950/30 sm:grid">
                  ⚙️
                </div>

                <div className="min-w-0">
                  <h1 className="break-words text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl">
                    {copy.settings}
                  </h1>

                  <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-200 sm:text-base sm:leading-7">
                    {copy.subtitle}
                  </p>
                </div>
              </div>
            </div>

<div className="settings-hero-actions flex w-full min-w-0 max-w-full flex-col gap-3 sm:flex-row xl:w-auto xl:items-center">

              <div className="rounded-2xl border border-white/15 bg-white/10 p-2 backdrop-blur">
                <div className="px-2 pb-1 text-[11px] font-extrabold uppercase tracking-wider text-slate-300">
                  {copy.uiLanguage}
                </div>

                <LanguageSegment
                  value={uiLanguage}
                  onChange={
                    changeUiLanguage
                  }
                />
              </div>

              <button
                type="button"
                onClick={saveSettings}
                disabled={isSaving}
                className={[
                  "min-h-[54px] rounded-2xl px-6 py-3 text-base font-black shadow-xl transition",
                  isSaving
                    ? "cursor-not-allowed bg-slate-500 text-white"
                    : "bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-orange-950/30 hover:-translate-y-0.5 hover:from-orange-400 hover:to-orange-500 active:translate-y-0",
                ].join(" ")}
              >
                {isSaving
                  ? `⏳ ${copy.saving}`
                  : `💾 ${copy.saveChanges}`}
              </button>
            </div>
          </div>

<div className="settings-summary-grid relative z-10 mt-7 grid grid-cols-1 gap-3 sm:grid-cols-3">

            <div className="rounded-2xl border border-white/10 bg-white/[0.08] p-4 backdrop-blur">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-300">
                {copy.profileCompletion}
              </div>

              <div className="mt-2 flex items-end justify-between gap-3">
                <div className="text-2xl font-black">
                  %{profileCompletion}
                </div>

                <div className="h-2 flex-1 overflow-hidden rounded-full bg-white/10">
                  <div
                    className="h-full rounded-full bg-gradient-to-r from-blue-400 to-orange-400 transition-all duration-500"
                    style={{
                      width: `${profileCompletion}%`,
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/[0.08] p-4 backdrop-blur">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-300">
                {copy.menuVisibility}
              </div>

              <div className="mt-2 text-2xl font-black">
                {visibleMenuItems.length}

                <span className="ml-1 text-sm font-semibold text-slate-300">
                  / {PANEL_MENU_ITEMS.length}
                </span>
              </div>
            </div>

            <div className="rounded-2xl border border-white/10 bg-white/[0.08] p-4 backdrop-blur">
              <div className="text-xs font-bold uppercase tracking-wider text-slate-300">
                {copy.languageCount}
              </div>

              <div className="mt-2 flex items-center gap-2">
                <div className="text-2xl font-black">
                  {
                    activeContentLanguages.length
                  }
                </div>

                <div className="flex flex-wrap gap-1">
                  {activeContentLanguages.map(
                    (languageCode) => (
                      <span
                        key={languageCode}
                        className="rounded-full bg-white/10 px-2 py-1 text-[11px] font-black uppercase"
                      >
                        {languageCode}
                      </span>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

       {/* HIZLI ERİŞİM - STOK SAYFASI SEKME MANTIĞI */}

<section className="settings-quick-card">
  <div className="settings-quick-title">
    <span className="settings-quick-title-icon">
      ⚡
    </span>

    <span className="settings-quick-title-text">
      {copy.quickAccess}
    </span>
  </div>

  <div className="settings-quick-scroll settings-scrollbar">
    <div className="settings-quick-row">
      {[
        {
          id: "institution-settings",
          icon: "🏢",
          label: copy.institutionInfo,
        },
        {
          id: "panel-menu-settings",
          icon: "🧭",
          label: copy.panelMenuVisibility,
        },
        {
          id: "downloads-settings",
          icon: "📎",
          label: copy.downloads,
        },
        {
          id: "security-settings",
          icon: "🔐",
          label: copy.security,
        },
        {
          id: "users-settings",
          icon: "👥",
          label: copy.users,
        },
      ].map((quickItem) => (
        <button
          key={quickItem.id}
          type="button"
          className="settings-quick-button"
          onClick={() => {
            const targetElement =
              document.getElementById(
                quickItem.id
              );

            if (!targetElement) {
              return;
            }

            targetElement.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
        >
          <span className="settings-quick-button-icon">
            {quickItem.icon}
          </span>

          <span className="settings-quick-button-text">
            {quickItem.label}
          </span>
        </button>
      ))}
    </div>
  </div>
</section>


        {/* İÇERİK DİLLERİ */}

        <section className="mt-5 rounded-[26px] border border-slate-200/80 bg-white p-4 shadow-xl shadow-slate-200/40 sm:p-6">
          <SectionHeader
            icon="🌍"
            title={copy.contentLanguages}
            description={copy.editedLanguage}
            action={
              <div className="flex flex-wrap gap-2">
                {LANGUAGES.map(
                  (language) => {
                    const active =
                      activeContentLanguages.includes(
                        language.code
                      );

                    return (
                      <button
                        key={language.code}
                        type="button"
                        onClick={() =>
                          toggleContentLanguage(
                            language.code
                          )
                        }
                        className={[
                          "rounded-xl border px-3 py-2 text-sm font-black transition",
                          active
                            ? "border-blue-600 bg-blue-600 text-white shadow-md shadow-blue-100"
                            : "border-slate-200 bg-white text-slate-600 hover:border-blue-300 hover:bg-blue-50",
                        ].join(" ")}
                      >
                        {active ? "✓ " : ""}
                        {language.label}
                      </button>
                    );
                  }
                )}
              </div>
            }
          />

          <div className="mt-5 flex flex-wrap items-center gap-2 rounded-2xl bg-slate-50 p-2">
            {activeLanguageOptions.map(
              (language) => (
                <button
                  key={language.code}
                  type="button"
                  onClick={() =>
                    setContentLanguage(
                      language.code
                    )
                  }
                  className={[
                    "rounded-xl px-4 py-2 text-sm font-black transition",
                    contentLanguage ===
                    language.code
                      ? "bg-gradient-to-r from-blue-600 to-orange-500 text-white shadow"
                      : "text-slate-600 hover:bg-white",
                  ].join(" ")}
                >
                  {language.label}
                </button>
              )
            )}
          </div>
        </section>

        {/* KURUM BİLGİLERİ */}

        <div
          id="institution-settings"
          className="mt-5 grid min-w-0 scroll-mt-24 grid-cols-1 gap-5 xl:grid-cols-12"
        >
          <section className="min-w-0 rounded-[26px] border border-slate-200/80 bg-white p-4 shadow-xl shadow-slate-200/40 sm:p-6 xl:col-span-7">
            <SectionHeader
              icon="🏢"
              title={copy.institutionInfo}
              description={
                copy.institutionInfoDesc
              }
            />

            <div className="mt-6 grid min-w-0 grid-cols-1 gap-4 md:grid-cols-2">
              <Field
                label={`${copy.companyName} (${contentLanguage.toUpperCase()})`}
                value={
                  companyNameByLanguage[
                    contentLanguage
                  ] || ""
                }
                onChange={(event) =>
                  setCompanyNameByLanguage(
                    (previousValues) => ({
                      ...previousValues,
                      [contentLanguage]:
                        event.target.value,
                    })
                  )
                }
                placeholder={
                  copy.companyName
                }
              />

              <Field
                label={`${copy.slogan} (${contentLanguage.toUpperCase()})`}
                value={
                  sloganByLanguage[
                    contentLanguage
                  ] || ""
                }
                onChange={(event) =>
                  setSloganByLanguage(
                    (previousValues) => ({
                      ...previousValues,
                      [contentLanguage]:
                        event.target.value,
                    })
                  )
                }
                placeholder={copy.slogan}
              />

              <Field
                label={copy.branch}
                value={branchName}
                onChange={(event) =>
                  setBranchName(
                    event.target.value
                  )
                }
              />

              <Field
                label={copy.authorized}
                value={authorizedName}
                onChange={(event) =>
                  setAuthorizedName(
                    event.target.value
                  )
                }
              />

              <Field
                label={copy.city}
                value={city}
                onChange={(event) =>
                  setCity(event.target.value)
                }
              />

              <Field
                label={copy.district}
                value={district}
                onChange={(event) =>
                  setDistrict(
                    event.target.value
                  )
                }
              />

              <Field
                label={copy.phone}
                type="tel"
                value={phone}
                onChange={(event) =>
                  setPhone(event.target.value)
                }
              />

              <Field
                label={copy.email}
                type="email"
                value={email}
                onChange={(event) =>
                  setEmail(event.target.value)
                }
              />

              <Field
                label={copy.website}
                type="url"
                value={website}
                onChange={(event) =>
                  setWebsite(
                    event.target.value
                  )
                }
                placeholder="https://..."
                className="md:col-span-2"
              />
            </div>
          </section>

          {/* LOGO */}

          <section className="min-w-0 rounded-[26px] border border-slate-200/80 bg-white p-4 shadow-xl shadow-slate-200/40 sm:p-6 xl:col-span-5">
            <SectionHeader
              icon="🖼️"
              title={copy.logoBrand}
              description={copy.logoBrandDesc}
            />

            <div className="mt-6 grid min-w-0 grid-cols-1 gap-5 sm:grid-cols-[128px_minmax(0,1fr)] sm:items-center">
              <div className="mx-auto grid h-28 w-28 place-items-center overflow-hidden rounded-[28px] border border-slate-200 bg-gradient-to-br from-slate-50 to-blue-50 shadow-inner sm:mx-0">
                {logoPreview ? (
                  <img
                    key={logoPreview}
                    src={logoPreview}
                    alt="Logo"
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <span className="text-4xl opacity-50">
                    🖼️
                  </span>
                )}
              </div>

              <div className="min-w-0 space-y-3">
                <input
                  value={logo || ""}
                  onChange={(event) =>
                    setLogo(event.target.value)
                  }
                  onBlur={(event) => {
                    setLogo(
                      normalizeUploadUrl(
                        event.target.value
                      )
                    );

                    setLogoVersion(
                      (previousVersion) =>
                        previousVersion + 1
                    );
                  }}
                  className="w-full min-w-0 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none transition focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                  placeholder={copy.logoUrl}
                />

                <div className="overflow-hidden rounded-2xl border border-dashed border-blue-200 bg-blue-50/60 p-3">
                  <ResimUpload
                    label={copy.logoUpload}
                    onUpload={(url) => {
                      const normalizedUrl =
                        normalizeUploadUrl(url);

                      setLogo(normalizedUrl);

                      setLogoVersion(
                        (previousVersion) =>
                          previousVersion + 1
                      );

                      localStorage.setItem(
                        "app_logo_url",
                        normalizedUrl
                      );

                      window.dispatchEvent(
                        new Event(
                          "app_settings_change"
                        )
                      );
                    }}
                    defaultPreview={
                      logoPreview || undefined
                    }
                  />
                </div>

                <p className="text-xs leading-5 text-slate-500">
                  {copy.logoHint}
                </p>
              </div>
            </div>
          </section>

          {/* SOSYAL MEDYA */}

          <section className="min-w-0 rounded-[26px] border border-slate-200/80 bg-white p-4 shadow-xl shadow-slate-200/40 sm:p-6 xl:col-span-7">
            <SectionHeader
              icon="🌐"
              title={copy.socialTheme}
              description={
                copy.socialThemeDesc
              }
            />

            <div className="mt-6 grid min-w-0 grid-cols-1 gap-4 md:grid-cols-2">
              <Field
                label={copy.facebook}
                value={facebook}
                onChange={(event) =>
                  setFacebook(
                    event.target.value
                  )
                }
                placeholder="https://facebook.com/..."
              />

              <Field
                label={copy.instagram}
                value={instagram}
                onChange={(event) =>
                  setInstagram(
                    event.target.value
                  )
                }
                placeholder="https://instagram.com/..."
              />

              <Field
                label={copy.twitter}
                value={twitter}
                onChange={(event) =>
                  setTwitter(
                    event.target.value
                  )
                }
                placeholder="https://x.com/..."
              />

              <Field
                label={copy.linkedin}
                value={linkedin}
                onChange={(event) =>
                  setLinkedin(
                    event.target.value
                  )
                }
                placeholder="https://linkedin.com/..."
              />

              <Field
                label={copy.youtube}
                value={youtube}
                onChange={(event) =>
                  setYoutube(
                    event.target.value
                  )
                }
                placeholder="https://youtube.com/..."
                className="md:col-span-2"
              />
            </div>
          </section>

          {/* TEMA */}

          <section className="min-w-0 rounded-[26px] border border-slate-200/80 bg-white p-4 shadow-xl shadow-slate-200/40 sm:p-6 xl:col-span-5">
            <SectionHeader
              icon="🎨"
              title={copy.theme}
              description={
                copy.menuServiceSettingsDesc
              }
            />

            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              <button
                type="button"
                onClick={() =>
                  setTheme("light")
                }
                className={[
                  "rounded-2xl border p-4 text-left transition",
                  theme === "light"
                    ? "border-blue-500 bg-blue-50 ring-4 ring-blue-100"
                    : "border-slate-200 bg-white hover:border-slate-300",
                ].join(" ")}
              >
                <div className="text-2xl">
                  ☀️
                </div>

                <div className="mt-2 font-black text-slate-900">
                  {copy.lightTheme}
                </div>

                <div className="mt-1 text-xs leading-5 text-slate-500">
                  {copy.lightThemeDesc}
                </div>
              </button>

              <button
                type="button"
                onClick={() =>
                  setTheme("dark")
                }
                className={[
                  "rounded-2xl border p-4 text-left transition",
                  theme === "dark"
                    ? "border-slate-700 bg-slate-900 text-white ring-4 ring-slate-200"
                    : "border-slate-200 bg-white hover:border-slate-300",
                ].join(" ")}
              >
                <div className="text-2xl">
                  🌙
                </div>

                <div
                  className={[
                    "mt-2 font-black",
                    theme === "dark"
                      ? "text-white"
                      : "text-slate-900",
                  ].join(" ")}
                >
                  {copy.darkTheme}
                </div>

                <div
                  className={[
                    "mt-1 text-xs leading-5",
                    theme === "dark"
                      ? "text-slate-300"
                      : "text-slate-500",
                  ].join(" ")}
                >
                  {copy.darkThemeDesc}
                </div>
              </button>
            </div>

            <div className="mt-5 space-y-3">
              <Toggle
                checked={menuEnabled}
                onChange={(event) =>
                  setMenuEnabled(
                    event.target.checked
                  )
                }
                title={copy.menuEnabled}
                description={
                  copy.menuEnabledDesc
                }
              />

              {menuEnabled && (
                <Toggle
                  checked={
                    allergensEnabled
                  }
                  onChange={(event) =>
                    setAllergensEnabled(
                      event.target.checked
                    )
                  }
                  title={
                    copy.allergensEnabled
                  }
                  description={
                    copy.allergensEnabledDesc
                  }
                />
              )}
            </div>
          </section>
        </div>

        {/* PANEL MENÜ GÖRÜNÜRLÜĞÜ */}

        <section
          id="panel-menu-settings"
          className="mt-5 min-w-0 scroll-mt-24 rounded-[28px] border border-slate-200/80 bg-white p-4 shadow-2xl shadow-slate-200/50 sm:p-6"
        >
          <SectionHeader
            icon="🧭"
            title={
              copy.panelMenuVisibility
            }
            description={
              copy.panelMenuVisibilityDesc
            }
            action={
              <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row">
                <button
                  type="button"
                  onClick={enableAllMenus}
                  className="rounded-xl bg-gradient-to-r from-blue-600 to-blue-700 px-4 py-2.5 text-sm font-black text-white shadow-md shadow-blue-100 transition hover:-translate-y-0.5"
                >
                  ✓ {copy.enableAll}
                </button>

                <button
                  type="button"
                  onClick={disableAllMenus}
                  className="rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-black text-slate-700 transition hover:border-orange-300 hover:bg-orange-50"
                >
                  × {copy.disableAll}
                </button>
              </div>
            }
          />

          <div className="mt-5 grid grid-cols-1 gap-3 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center">
            <div className="relative min-w-0">
              <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400">
                🔎
              </span>

              <input
                value={menuSearch}
                onChange={(event) =>
                  setMenuSearch(
                    event.target.value
                  )
                }
                placeholder={copy.searchMenu}
                className="w-full min-w-0 rounded-2xl border border-slate-200 bg-slate-50 py-3 pl-11 pr-4 text-sm font-semibold text-slate-900 outline-none transition focus:border-blue-500 focus:bg-white focus:ring-4 focus:ring-blue-100"
              />
            </div>

            <div className="flex flex-wrap items-center gap-2">
              <span className="rounded-full bg-blue-50 px-3 py-2 text-xs font-black text-blue-700">
                {visibleMenuItems.length} /{" "}
                {PANEL_MENU_ITEMS.length}{" "}
                {copy.enabledMenus}
              </span>

              <span className="rounded-full bg-orange-50 px-3 py-2 text-xs font-bold text-orange-700">
                🔒{" "}
                {copy.settingsLogoutAlways}
              </span>
            </div>
          </div>











          <div className="mt-5 space-y-7">
            {[
              {
                key: "home",
                title: null,
                menuKeys: [
                  "home",
                ],
              },

              {
                key: "menuOrders",
                title: {
                  tr: "Menü ve Sipariş Yönetimi",
                  en: "Menu and Order Management",
                  de: "Menü- und Bestellverwaltung",
                },
                menuKeys: [
                  "menuManagement",
                  "orders",
                  "TelefonSiparis",
                  "liveTables",
                ],
              },

              {
                key: "finance",
                title: {
                  tr: "Finans ve Ticari İşlemler",
                  en: "Finance and Commercial Operations",
                  de: "Finanzen und Geschäftsprozesse",
                },
                menuKeys: [
                  "cashCollection",
                  "cari",
                  "stockManagement",
                  "accounting",
                  "fiscalPos",
                ],
              },

              {
                key: "institutionContent",
                title: {
                  tr: "Kurum Sayfası ve İçerikler",
                  en: "Institution Page and Content",
                  de: "Institutionsseite und Inhalte",
                },
                menuKeys: [
                  "mainCategories",
                  "homepageManagement",
                  "activities",
                  "announcements",
                  "events",
                  "contact",
                  "documents",
                  "cemetery",
                  "qrCode",
                ],
              },

              {
                key: "customerCommunication",
                title: {
                  tr: "Müşteri ve İletişim",
                  en: "Customer and Communication",
                  de: "Kunden und Kommunikation",
                },
                menuKeys: [
                  "appointments",
                  "messageCenter",
                  "polls",
                  "feedback",
                  "digitalSignature",
                ],
              },

              {
                key: "sectorModules",
                title: {
                  tr: "Sektörel Modüller",
                  en: "Industry Modules",
                  de: "Branchenmodule",
                },
                menuKeys: [
                  "beauty",
                  "hotel",
                  "coursePrograms",
                  "marketplace",
                ],
              },

              {
                key: "networkManagement",
                title: {
                  tr: "İş Ağı ve Yönetim",
                  en: "Business Network and Management",
                  de: "Geschäftsnetzwerk und Verwaltung",
                },
                menuKeys: [
                  "businessNetwork",
                  "mesyatPara",
                  "franchiseSystem",
                  "integrations",
                  "users",
                ],
              },
            ].map((group) => {
              const groupItems =
                group.menuKeys
                  .map((menuKey) =>
                    filteredMenuItems.find(
                      (menuItem) =>
                        menuItem.key ===
                        menuKey
                    )
                  )
                  .filter(Boolean);

              if (groupItems.length === 0) {
                return null;
              }

              return (
                <section key={group.key}>
                  {group.title && (
                    <div className="mb-3 flex items-center gap-3">
                      <h3 className="shrink-0 text-xs font-black uppercase tracking-wide text-orange-600">
                        {group.title[
                          uiLanguage
                        ] || group.title.tr}
                      </h3>

                      <span className="h-0.5 min-w-6 flex-1 rounded-full bg-gradient-to-r from-orange-500 to-orange-200" />
                    </div>
                  )}

                  <div className="grid min-w-0 grid-cols-1 gap-3 md:grid-cols-2 2xl:grid-cols-3">
                    {groupItems.map(
                      (menuItem) => {
                        const checked =
                          visibleMenuItems.includes(
                            menuItem.key
                          );

                        const label =
                          menuItem.labels?.[
                            uiLanguage
                          ] ||
                          menuItem.labels?.tr ||
                          menuItem.key;

                        const description =
                          menuItem.descriptions?.[
                            uiLanguage
                          ] ||
                          menuItem
                            .descriptions?.tr ||
                          "";

                        return (
                          <article
                            key={
                              menuItem.key
                            }
                            className={[
                              "group min-w-0 rounded-2xl border p-4 transition-all duration-200",
                              checked
                                ? "border-blue-300 bg-gradient-to-br from-blue-50 via-white to-orange-50 shadow-md shadow-blue-100/60"
                                : "border-slate-200 bg-white hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md",
                            ].join(" ")}
                          >
                            <label className="flex min-w-0 cursor-pointer items-start gap-3">
                              <span
                                className={[
                                  "grid h-11 w-11 shrink-0 place-items-center rounded-2xl text-xl transition",
                                  checked
                                    ? "bg-gradient-to-br from-blue-600 to-orange-500 text-white shadow"
                                    : "bg-slate-100 text-slate-700 group-hover:bg-blue-50",
                                ].join(" ")}
                              >
                                {
                                  menuItem.icon
                                }
                              </span>

                              <span className="min-w-0 flex-1">
                                <span className="block break-words text-[15px] font-black leading-5 text-slate-900">
                                  {label}
                                </span>

                                <span className="mt-1 block break-words text-xs leading-5 text-slate-500">
                                  {
                                    description
                                  }
                                </span>

                                <span className="mt-2 inline-flex max-w-full break-all rounded-full bg-slate-100 px-2 py-1 font-mono text-[10px] text-slate-500">
                                  {
                                    menuItem.key
                                  }
                                </span>
                              </span>

                              <span className="relative mt-1 inline-flex h-7 w-12 shrink-0 items-center">
                                <input
                                  type="checkbox"
                                  checked={
                                    checked
                                  }
                                  onChange={() =>
                                    toggleMenuItem(
                                      menuItem.key
                                    )
                                  }
                                  className="peer sr-only"
                                />

                                <span className="absolute inset-0 rounded-full bg-slate-300 transition peer-checked:bg-gradient-to-r peer-checked:from-blue-600 peer-checked:to-orange-500 peer-focus:ring-4 peer-focus:ring-blue-100" />

                                <span className="absolute left-1 h-5 w-5 rounded-full bg-white shadow transition-transform peer-checked:translate-x-5" />
                              </span>
                            </label>

                            {menuItem.key ===
                              "marketplace" &&
                              checked && (
                                <div className="mt-4 border-t border-slate-200 pt-4">
                                  <label className="block text-xs font-black uppercase tracking-wide text-slate-500">
                                    {
                                      copy.marketplaceVisibility
                                    }
                                  </label>

                                  <p className="mt-1 text-xs leading-5 text-slate-500">
                                    {
                                      copy.marketplaceVisibilityDesc
                                    }
                                  </p>

                                  <select
                                    value={
                                      marketplaceVisibility ===
                                      "none"
                                        ? "all"
                                        : marketplaceVisibility
                                    }
                                    onChange={(
                                      event
                                    ) =>
                                      setMarketplaceVisibility(
                                        event
                                          .target
                                          .value
                                      )
                                    }
                                    className="mt-2 w-full rounded-xl border border-slate-200 bg-white px-3 py-2.5 text-sm font-bold text-slate-800 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                                  >
                                    <option value="all">
                                      {
                                        copy.marketplaceAll
                                      }
                                    </option>

                                    <option value="sector">
                                      {
                                        copy.marketplaceOtherSector
                                      }
                                    </option>
                                  </select>
                                </div>
                              )}
                          </article>
                        );
                      }
                    )}
                  </div>
                </section>
              );
            })}
          </div>










          {filteredMenuItems.length === 0 && (
            <div className="mt-5 rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-8 text-center text-sm font-semibold text-slate-500">
              🔎 {copy.noMenuResult}
            </div>
          )}

          <div className="mt-5 rounded-2xl border border-blue-100 bg-gradient-to-r from-blue-50 to-orange-50 p-4 text-sm leading-6 text-slate-700">
            <strong className="text-slate-900">
              Bilgi:
            </strong>{" "}
            {copy.moduleSyncInfo}
          </div>
        </section>

        {/* DOSYA VE LİNKLER */}

        <section
          id="downloads-settings"
          className="mt-5 min-w-0 scroll-mt-24 rounded-[28px] border border-slate-200/80 bg-white p-4 shadow-xl shadow-slate-200/40 sm:p-6"
        >
          <SectionHeader
            icon="📎"
            title={copy.downloads}
            description={copy.downloadsDesc}
          />

          <div className="mt-6 grid min-w-0 grid-cols-1 gap-5 xl:grid-cols-[minmax(0,420px)_minmax(0,1fr)]">
            <div className="min-w-0 rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <div className="mb-4">
                <div className="font-black text-slate-900">
                  {editingDownloadId !== null
                    ? copy.editDownload
                    : copy.newDownload}
                </div>

                <div className="mt-1 text-xs text-slate-500">
                  {contentLanguage.toUpperCase()}
                </div>
              </div>

              <div className="space-y-3">
                <input
                  value={
                    downloadDraft.title?.[
                      contentLanguage
                    ] || ""
                  }
                  onChange={(event) =>
                    setDownloadDraft(
                      (previousDraft) => ({
                        ...previousDraft,
                        title: {
                          ...previousDraft.title,
                          [contentLanguage]:
                            event.target.value,
                        },
                      })
                    )
                  }
                  placeholder={copy.title}
                  className="w-full min-w-0 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                />

                <textarea
                  value={
                    downloadDraft.description?.[
                      contentLanguage
                    ] || ""
                  }
                  onChange={(event) =>
                    setDownloadDraft(
                      (previousDraft) => ({
                        ...previousDraft,
                        description: {
                          ...previousDraft.description,
                          [contentLanguage]:
                            event.target.value,
                        },
                      })
                    )
                  }
                  placeholder={
                    copy.description
                  }
                  className="min-h-[110px] w-full min-w-0 resize-y rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                />

                <div className="overflow-hidden rounded-2xl border border-dashed border-blue-200 bg-blue-50/60 p-3">
                  <ResimUpload
                    label={copy.uploadFile}
                    mode="all"
                    onUpload={(url) =>
                      setDownloadDraft(
                        (previousDraft) => ({
                          ...previousDraft,
                          file: normalizeUploadUrl(
                            url
                          ),
                        })
                      )
                    }
                  />
                </div>

                {downloadDraft.file && (
                  <div className="break-all rounded-xl bg-emerald-50 p-3 text-xs font-semibold text-emerald-700">
                    📄 {downloadDraft.file}
                  </div>
                )}

                <input
                  value={
                    downloadDraft.link || ""
                  }
                  onChange={(event) =>
                    setDownloadDraft(
                      (previousDraft) => ({
                        ...previousDraft,
                        link: event.target.value,
                      })
                    )
                  }
                  placeholder="https://..."
                  className="w-full min-w-0 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                />

                <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                  <button
                    type="button"
                    onClick={
                      saveDownloadDraft
                    }
                    className="rounded-2xl bg-gradient-to-r from-blue-600 to-blue-700 px-4 py-3 font-black text-white shadow-md shadow-blue-100 transition hover:-translate-y-0.5"
                  >
                    {editingDownloadId !==
                    null
                      ? `💾 ${copy.update}`
                      : `➕ ${copy.add}`}
                  </button>

                  <button
                    type="button"
                    onClick={
                      resetDownloadDraft
                    }
                    className="rounded-2xl border border-slate-200 bg-white px-4 py-3 font-black text-slate-700 transition hover:bg-slate-100"
                  >
                    {copy.clear}
                  </button>
                </div>
              </div>
            </div>

            <div className="min-w-0 space-y-3">
              {downloads.length === 0 ? (
                <div className="grid min-h-[240px] place-items-center rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-8 text-center">
                  <div>
                    <div className="text-4xl">
                      📂
                    </div>

                    <div className="mt-3 text-sm font-bold text-slate-500">
                      {copy.noDownloads}
                    </div>
                  </div>
                </div>
              ) : (
                downloads.map(
                  (download) => (
                    <article
                      key={download.id}
                      className="min-w-0 rounded-2xl border border-slate-200 bg-white p-4 transition hover:border-blue-200 hover:shadow-md"
                    >
                      <div className="flex min-w-0 flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                        <div className="min-w-0 flex-1">
                          <h3 className="break-words text-base font-black text-slate-900">
                            {download.title?.[
                              contentLanguage
                            ] ||
                              download.title
                                ?.tr ||
                              copy.untitled}
                          </h3>

                          {(download
                            .description?.[
                            contentLanguage
                          ] ||
                            download
                              .description
                              ?.tr) && (
                            <p className="mt-2 break-words text-sm leading-6 text-slate-600">
                              {download
                                .description?.[
                                contentLanguage
                              ] ||
                                download
                                  .description
                                  ?.tr}
                            </p>
                          )}

                          <div className="mt-3 flex min-w-0 flex-col gap-2">
                            {download.file && (
                              <a
                                href={
                                  download.file
                                }
                                target="_blank"
                                rel="noreferrer"
                                className="min-w-0 break-all rounded-xl bg-emerald-50 px-3 py-2 text-xs font-bold text-emerald-700"
                              >
                                📄{" "}
                                {copy.file}:{" "}
                                {
                                  download.file
                                }
                              </a>
                            )}

                            {download.link && (
                              <a
                                href={
                                  download.link
                                }
                                target="_blank"
                                rel="noreferrer"
                                className="min-w-0 break-all rounded-xl bg-blue-50 px-3 py-2 text-xs font-bold text-blue-700"
                              >
                                🔗{" "}
                                {copy.link}:{" "}
                                {
                                  download.link
                                }
                              </a>
                            )}
                          </div>
                        </div>

                                            <div className="flex shrink-0 flex-wrap gap-2">
                          <button
                            type="button"
                            onClick={() =>
                              sendDownload(
                                download
                              )
                            }
                            disabled={
                              sendingDownloadId ===
                              download.id
                            }
                            className="rounded-xl border border-blue-200 bg-blue-50 px-3 py-2 text-sm font-black text-blue-700 transition hover:bg-blue-100 disabled:cursor-not-allowed disabled:opacity-60"
                          >
                            {sendingDownloadId ===
                            download.id
                              ? `⏳ ${copy.sending}`
                              : `📤 ${copy.send}`}
                          </button>

                          <button
                            type="button"
                            onClick={() =>
                              editDownload(
                                download
                              )
                            }
                            className="rounded-xl border border-orange-200 bg-orange-50 px-3 py-2 text-sm font-black text-orange-700 transition hover:bg-orange-100"
                          >
                            ✏️ {copy.edit}
                          </button>

                          <button
                            type="button"
                            onClick={() =>
                              deleteDownload(
                                download.id
                              )
                            }
                            className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-sm font-black text-red-700 transition hover:bg-red-100"
                          >
                            🗑 {copy.delete}
                          </button>
                        </div>
                      </div>
                    </article>
                  )
                )
              )}
            </div>
          </div>
        </section>

        {/* ŞİFRE DEĞİŞTİR */}

        <section
          id="security-settings"
          className="mt-5 scroll-mt-24 overflow-hidden rounded-[28px] border border-slate-200/80 bg-white shadow-xl shadow-slate-200/40"
        >
          <button
            type="button"
            onClick={() =>
              setPasswordOpen(
                (previousValue) =>
                  !previousValue
              )
            }
            className="flex w-full items-center justify-between gap-4 p-5 text-left transition hover:bg-slate-50 sm:p-6"
          >
            <div className="flex min-w-0 items-start gap-3">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-red-500 to-orange-500 text-xl text-white shadow">
                🔐
              </span>

              <div className="min-w-0">
                <div className="text-lg font-black text-slate-900">
                  {copy.changePassword}
                </div>

                <div className="mt-1 text-sm leading-6 text-slate-500">
                  {copy.changePasswordDesc}
                </div>
              </div>
            </div>

            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-slate-100 text-xl font-black text-slate-600">
              {passwordOpen ? "−" : "+"}
            </span>
          </button>

          {passwordOpen && (
            <div className="border-t border-slate-200 bg-slate-50 p-4 sm:p-6">
              <div className="mx-auto grid max-w-4xl grid-cols-1 gap-4 md:grid-cols-3">
                <Field
                  label={
                    copy.currentPassword
                  }
                  type="password"
                  value={currentPassword}
                  onChange={(event) =>
                    setCurrentPassword(
                      event.target.value
                    )
                  }
                />

                <Field
                  label={copy.newPassword}
                  type="password"
                  value={newPassword}
                  onChange={(event) =>
                    setNewPassword(
                      event.target.value
                    )
                  }
                />

                <Field
                  label={
                    copy.repeatPassword
                  }
                  type="password"
                  value={newPasswordAgain}
                  onChange={(event) =>
                    setNewPasswordAgain(
                      event.target.value
                    )
                  }
                />
              </div>

              <div className="mx-auto mt-4 max-w-4xl">
                <button
                  type="button"
                  onClick={changePassword}
                  disabled={passwordLoading}
                  className={[
                    "w-full rounded-2xl px-5 py-3 font-black text-white shadow transition",
                    passwordLoading
                      ? "cursor-not-allowed bg-slate-400"
                      : "bg-gradient-to-r from-red-600 to-orange-500 hover:-translate-y-0.5",
                  ].join(" ")}
                >
                  {passwordLoading
                    ? "⏳"
                    : "🔐"}{" "}
                  {copy.updatePassword}
                </button>
              </div>
            </div>
          )}
        </section>

        {/* KULLANICILAR */}

        <section
          id="users-settings"
          className="mt-5 scroll-mt-24 overflow-hidden rounded-[28px] border border-slate-200/80 bg-white shadow-2xl shadow-slate-200/50"
        >
          <button
            type="button"
            onClick={() =>
              setAuthorizationOpen(
                (previousValue) =>
                  !previousValue
              )
            }
            className="flex w-full items-center justify-between gap-4 p-5 text-left transition hover:bg-slate-50 sm:p-6"
          >
            <div className="flex min-w-0 items-start gap-3">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-2xl bg-gradient-to-br from-blue-600 to-orange-500 text-xl text-white shadow">
                👥
              </span>

              <div className="min-w-0">
                <div className="text-lg font-black text-slate-900 sm:text-xl">
                  {
                    copy.usersAuthorization
                  }
                </div>

                <div className="mt-1 text-sm leading-6 text-slate-500">
                  {
                    copy.usersAuthorizationDesc
                  }
                </div>
              </div>
            </div>

            <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-slate-100 text-xl font-black text-slate-600">
              {authorizationOpen
                ? "−"
                : "+"}
            </span>
          </button>

          {authorizationOpen && (
            <div className="space-y-6 border-t border-slate-200 bg-slate-50 p-4 sm:p-6">
              <div className="rounded-2xl border border-orange-200 bg-gradient-to-r from-orange-50 to-blue-50 p-4">
                <div className="font-black text-slate-900">
                  🔐 Kurumsal yetki sistemi
                </div>

                <div className="mt-1 text-sm leading-6 text-slate-700">
                  İlk ana kullanıcı tam
                  yetkilidir. Personel
                  kullanıcıları mevcut
                  yetkilendirme endpointiniz
                  üzerinden güvenli şekilde
                  yönetilir.
                </div>
              </div>

              <div className="grid min-w-0 grid-cols-1 gap-6 2xl:grid-cols-[420px_minmax(0,1fr)]">
                {/* KULLANICI FORMU */}

                <div className="min-w-0 space-y-4 rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
                  <div>
                    <div className="text-lg font-black text-slate-900">
                      {editingAuthUserId
                        ? `✏️ ${copy.editUser}`
                        : `➕ ${copy.newUser}`}
                    </div>

                    <div className="mt-1 text-sm leading-6 text-slate-500">
                      Kullanıcı bilgileri,
                      rolü ve şube kapsamını
                      belirleyin.
                    </div>
                  </div>

                  <Field
                    label={copy.fullName}
                    value={authDraft.name}
                    onChange={(event) =>
                      setAuthDraft(
                        (previousDraft) => ({
                          ...previousDraft,
                          name: event.target
                            .value,
                        })
                      )
                    }
                    placeholder="Örn: Ahmet Yılmaz"
                  />

                  <Field
                    label={copy.username}
                    value={
                      authDraft.username
                    }
                    onChange={(event) =>
                      setAuthDraft(
                        (previousDraft) => ({
                          ...previousDraft,
                          username:
                            event.target
                              .value,
                        })
                      )
                    }
                    placeholder="ornek@firma.com"
                  />

                  <Field
                    label={
                      editingAuthUserId
                        ? copy.optionalPassword
                        : copy.password
                    }
                    type="password"
                    value={
                      authDraft.password
                    }
                    onChange={(event) =>
                      setAuthDraft(
                        (previousDraft) => ({
                          ...previousDraft,
                          password:
                            event.target
                              .value,
                        })
                      )
                    }
                    placeholder={
                      editingAuthUserId
                        ? "Boş bırakılırsa değişmez"
                        : "En az 6 karakter"
                    }
                  />

                  <div>
                    <label className="mb-1.5 block text-sm font-extrabold text-slate-700">
                      {copy.role}
                    </label>

                    <select
                      value={authDraft.role}
                      onChange={(event) =>
                        changeAuthRole(
                          event.target.value
                        )
                      }
                      className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-900 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                    >
                      {Object.entries(
                        ROLE_PRESETS
                      ).map(
                        ([
                          roleKey,
                          rolePreset,
                        ]) => (
                          <option
                            key={roleKey}
                            value={roleKey}
                          >
                            {
                              rolePreset.label
                            }
                          </option>
                        )
                      )}
                    </select>

                    <div className="mt-1 text-xs leading-5 text-slate-500">
                      {ROLE_PRESETS[
                        authDraft.role
                      ]?.description ||
                        ROLE_PRESETS.custom
                          .description}
                    </div>
                  </div>

                  <div>
                    <label className="mb-1.5 block text-sm font-extrabold text-slate-700">
                      {
                        copy.branchPermission
                      }
                    </label>

                    <select
                      value={
                        authDraft.branchScope
                      }
                      onChange={(event) =>
                        setAuthDraft(
                          (previousDraft) => ({
                            ...previousDraft,
                            branchScope:
                              event.target
                                .value,
                          })
                        )
                      }
                      className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-900 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                    >
                      <option value="all">
                        {copy.allBranches}
                      </option>

                      <option value="single">
                        {
                          copy.selectedBranch
                        }
                      </option>

                      <option value="custom">
                        {copy.customBranch}
                      </option>
                    </select>
                  </div>

                  {authDraft.branchScope !==
                    "all" && (
                    <Field
                      label={copy.branchName}
                      value={
                        authDraft.branchName
                      }
                      onChange={(event) =>
                        setAuthDraft(
                          (previousDraft) => ({
                            ...previousDraft,
                            branchName:
                              event.target
                                .value,
                          })
                        )
                      }
                      placeholder="Örn: Merkez Şube"
                    />
                  )}

                  <Toggle
                    checked={
                      authDraft.active
                    }
                    onChange={(event) =>
                      setAuthDraft(
                        (previousDraft) => ({
                          ...previousDraft,
                          active:
                            event.target
                              .checked,
                        })
                      )
                    }
                    title={copy.activeUser}
                    description={
                      copy.activeUserDesc
                    }
                  />

                  <textarea
                    value={authDraft.notes}
                    onChange={(event) =>
                      setAuthDraft(
                        (previousDraft) => ({
                          ...previousDraft,
                          notes:
                            event.target
                              .value,
                        })
                      )
                    }
                    className="min-h-[100px] w-full resize-y rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 outline-none focus:border-blue-500 focus:ring-4 focus:ring-blue-100"
                    placeholder={`${copy.internalNote}: Örn. Sadece akşam vardiyası`}
                  />

                  <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                    <button
                      type="button"
                      onClick={saveAuthUser}
                      className="rounded-2xl bg-gradient-to-r from-blue-600 to-blue-700 px-4 py-3 font-black text-white shadow-md shadow-blue-100 transition hover:-translate-y-0.5"
                    >
                      {editingAuthUserId
                        ? `💾 ${copy.updateUser}`
                        : `➕ ${copy.saveUser}`}
                    </button>

                    <button
                      type="button"
                      onClick={resetAuthDraft}
                      className="rounded-2xl border border-slate-200 bg-white px-4 py-3 font-black text-slate-700 transition hover:bg-slate-100"
                    >
                      {copy.clear}
                    </button>
                  </div>
                </div>

                {/* YETKİLER */}

                <div className="min-w-0 rounded-[24px] border border-slate-200 bg-white p-4 shadow-sm sm:p-5">
                  <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                    <div>
                      <div className="text-lg font-black text-slate-900">
                        {
                          copy.modulePermissions
                        }
                      </div>

                      <div className="mt-1 text-sm leading-6 text-slate-500">
                        {
                          copy.modulePermissionsDesc
                        }
                      </div>
                    </div>



           <div className="permission-top-actions">
  <button
    type="button"
    onClick={() =>
      toggleAllPermissions(true)
    }
    className="permission-select-button permission-select-button-active"
  >
    <span>✓</span>
    <span>{copy.selectAll}</span>
  </button>

  <button
    type="button"
    onClick={() =>
      toggleAllPermissions(false)
    }
    className="permission-select-button permission-select-button-passive"
  >
    <span>×</span>
    <span>{copy.clearAll}</span>
  </button>
</div>

</div>



                  <div className="mt-4 rounded-2xl border border-blue-100 bg-blue-50 p-3 text-sm text-blue-800">
                    {copy.selectedPermission}:{" "}
                    <strong>
                      {
                        Object.values(
                          authDraft.permissions ||
                            {}
                        ).filter(Boolean)
                          .length
                      }
                    </strong>{" "}
                    /{" "}
                    {
                      ALL_PERMISSION_KEYS.length
                    }
                  </div>

                  <div className="mt-4 space-y-2">
                    {PERMISSION_GROUPS.map(
                      (permissionGroup) => {
                        const permissionKeys =
                          permissionGroup.items.map(
                            (
                              permissionItem
                            ) =>
                              permissionItem.key
                          );

                        const allChecked =
                          permissionKeys.every(
                            (permissionKey) =>
                              authDraft
                                .permissions?.[
                                permissionKey
                              ]
                          );

                        const someChecked =
                          permissionKeys.some(
                            (permissionKey) =>
                              authDraft
                                .permissions?.[
                                permissionKey
                              ]
                          );

                        const selectedCount =
                          permissionKeys.filter(
                            (permissionKey) =>
                              authDraft
                                .permissions?.[
                                permissionKey
                              ]
                          ).length;

                        const opened =
                          openPermissionGroup ===
                          permissionGroup.title;

                        


return (
  <div
    key={permissionGroup.title}
    className={[
      "permission-group-card",
      opened
        ? "permission-group-card-open"
        : "",
      someChecked
        ? "permission-group-card-selected"
        : "",
    ].join(" ")}
  >
    <div className="permission-group-head">
      {/* GRUBU AÇ / KAPAT */}

      <button
        type="button"
        onClick={() =>
          setOpenPermissionGroup(
            opened
              ? null
              : permissionGroup.title
          )
        }
        className="permission-group-main"
      >
        <div className="permission-group-info">
          <div className="permission-group-title-row">
            <span className="permission-group-icon">
              {opened ? "📂" : "📁"}
            </span>

            <span className="permission-group-title">
              {permissionGroup.title}
            </span>

            <span
              className={[
                "permission-count-badge",
                selectedCount > 0
                  ? "permission-count-badge-active"
                  : "",
              ].join(" ")}
            >
              {selectedCount} /{" "}
              {permissionKeys.length}
            </span>
          </div>

          <div className="permission-group-description">
            {permissionGroup.description}
          </div>
        </div>

        <span
          className={[
            "permission-toggle-circle",
            opened
              ? "permission-toggle-circle-open"
              : "",
          ].join(" ")}
        >
          {opened ? "−" : "+"}
        </span>
      </button>

      {/* GRUBUN TÜMÜNÜ SEÇ */}

      <label
        className={[
          "permission-group-all",
          allChecked
            ? "permission-group-all-checked"
            : "",
          !allChecked && someChecked
            ? "permission-group-all-partial"
            : "",
        ].join(" ")}
      >
        <input
          type="checkbox"
          checked={allChecked}
          ref={(element) => {
            if (element) {
              element.indeterminate =
                !allChecked &&
                someChecked;
            }
          }}
          onChange={(event) =>
            togglePermissionGroup(
              permissionGroup,
              event.target.checked
            )
          }
        />

        <span className="permission-custom-checkbox">
          {allChecked
            ? "✓"
            : someChecked
            ? "•"
            : ""}
        </span>

        <span className="permission-all-text">
          {copy.all}
        </span>
      </label>
    </div>

    {opened && (
      <div className="permission-items-grid">
        {permissionGroup.items.map(
          (permissionItem) => {
            const permissionChecked =
              authDraft.permissions?.[
                permissionItem.key
              ] === true;

            return (
              <label
                key={permissionItem.key}
                className={[
                  "permission-item-row",
                  permissionChecked
                    ? "permission-item-row-checked"
                    : "",
                ].join(" ")}
              >
                <div className="permission-item-content">
                  <div className="permission-item-label">
                    {permissionItem.label}
                  </div>

                  <div className="permission-item-key">
                    {permissionItem.key}
                  </div>
                </div>

                <input
                  type="checkbox"
                  checked={permissionChecked}
                  onChange={() =>
                    togglePermission(
                      permissionItem.key
                    )
                  }
                  className="permission-item-input"
                />
              </label>
            );
          }
        )}
      </div>
    )}
  </div>
);



                      }
                    )}
                  </div>
                </div>
              </div>

              {/* KULLANICI LİSTESİ */}

              <div className="overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm">
                <div className="border-b border-slate-200 p-5">
                  <div className="text-lg font-black text-slate-900">
                    {copy.definedUsers}
                  </div>

                  <div className="mt-1 text-sm leading-6 text-slate-500">
                    Firma sahibi dışındaki
                    personel kullanıcıları
                    burada listelenir.
                  </div>
                </div>

                {authUsers.length === 0 ? (
                  <div className="p-8 text-center text-sm font-semibold text-slate-500">
                    👤{" "}
                    {copy.noDefinedUsers}
                  </div>
                ) : (
                  <div className="divide-y divide-slate-200">
                    {authUsers.map(
                      (user) => {
                        const selectedCount =
                          Object.values(
                            user.permissions ||
                              {}
                          ).filter(Boolean)
                            .length;

                        const roleLabel =
                          ROLE_PRESETS[
                            user.role
                          ]?.label ||
                          ROLE_PRESETS
                            .custom.label;

                        return (
                          <div
                            key={user.id}
                            className="flex flex-col gap-4 p-4 transition hover:bg-slate-50 sm:p-5 lg:flex-row lg:items-center lg:justify-between"
                          >
                            <div className="min-w-0">
                              <div className="flex flex-wrap items-center gap-2">
                                <div className="break-words text-lg font-black text-slate-900">
                                  {
                                    user.name
                                  }
                                </div>

                                <span
                                  className={[
                                    "rounded-full px-2.5 py-1 text-xs font-black",
                                    user.active
                                      ? "bg-emerald-100 text-emerald-700"
                                      : "bg-red-100 text-red-700",
                                  ].join(
                                    " "
                                  )}
                                >
                                  {user.active
                                    ? copy.active
                                    : copy.passive}
                                </span>
                              </div>

                              <div className="mt-2 break-words text-sm leading-6 text-slate-500">
                                Kullanıcı:{" "}
                                <strong className="text-slate-700">
                                  {
                                    user.username
                                  }
                                </strong>{" "}
                                · Rol:{" "}
                                <strong className="text-slate-700">
                                  {
                                    roleLabel
                                  }
                                </strong>
                              </div>

                              <div className="break-words text-sm leading-6 text-slate-500">
                                Şube:{" "}
                                <strong className="text-slate-700">
                                  {user.branchScope ===
                                  "all"
                                    ? copy.allBranches
                                    : user.branchName ||
                                      copy.selectedBranch}
                                </strong>{" "}
                                · Yetki:{" "}
                                <strong className="text-slate-700">
                                  {
                                    selectedCount
                                  }
                                </strong>{" "}
                                /{" "}
                                {
                                  ALL_PERMISSION_KEYS.length
                                }
                              </div>

                              {user.notes && (
                                <div className="mt-1 break-words text-xs text-slate-400">
                                  Not:{" "}
                                  {
                                    user.notes
                                  }
                                </div>
                              )}
                            </div>

                            <div className="flex shrink-0 flex-wrap gap-2">
                              <button
                                type="button"
                                onClick={() =>
                                  editAuthUser(
                                    user
                                  )
                                }
                                className="rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-black text-blue-700 transition hover:bg-blue-100"
                              >
                                ✏️{" "}
                                {copy.edit}
                              </button>

                              <button
                                type="button"
                                onClick={() =>
                                  toggleAuthUserActive(
                                    user
                                  )
                                }
                                className="rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-black text-slate-700 transition hover:bg-slate-100"
                              >
                                {user.active
                                  ? copy.makePassive
                                  : copy.makeActive}
                              </button>

                              <button
                                type="button"
                                onClick={() =>
                                  deleteAuthUser(
                                    user.id
                                  )
                                }
                                className="rounded-xl bg-red-600 px-4 py-2 text-sm font-black text-white transition hover:bg-red-700"
                              >
                                🗑{" "}
                                {copy.delete}
                              </button>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
        </section>

        {/* SABİT KAYDET */}

        <div className="sticky bottom-3 z-30 mt-5">
          <div className="flex flex-col gap-3 rounded-[24px] border border-white/80 bg-slate-950/95 p-3 shadow-2xl shadow-slate-400/50 backdrop-blur sm:flex-row sm:items-center sm:justify-between sm:p-4">
            <div className="min-w-0 px-1 text-sm leading-6 text-slate-300">
              <strong className="text-white">
                {visibleMenuItems.length} /{" "}
                {PANEL_MENU_ITEMS.length}
              </strong>{" "}
              {copy.enabledMenus} ·{" "}
              <strong className="text-white">
                {
                  activeContentLanguages.length
                }
              </strong>{" "}
              {copy.languageCount}
            </div>

            <button
              type="button"
              onClick={saveSettings}
              disabled={isSaving}
              className={[
                "w-full rounded-2xl px-6 py-3 text-base font-black shadow-xl transition sm:w-auto",
                isSaving
                  ? "cursor-not-allowed bg-slate-600 text-white"
                  : "bg-gradient-to-r from-blue-600 via-blue-600 to-orange-500 text-white hover:-translate-y-0.5",
              ].join(" ")}
            >
              {isSaving
                ? `⏳ ${copy.saving}`
                : `💾 ${copy.saveChanges}`}
            </button>
          </div>
        </div>

        {pageLoading && (
          <div className="fixed inset-0 z-[90] grid place-items-center bg-slate-950/35 p-4 backdrop-blur-sm">
            <div className="w-full max-w-sm rounded-[28px] border border-white/20 bg-white p-6 text-center shadow-2xl">
              <div className="mx-auto grid h-16 w-16 animate-pulse place-items-center rounded-3xl bg-gradient-to-br from-blue-600 to-orange-500 text-3xl text-white">
                ⚙️
              </div>

              <div className="mt-4 text-lg font-black text-slate-900">
                Ayarlar yükleniyor
              </div>

              <div className="mt-2 text-sm leading-6 text-slate-500">
                Kurum ve panel ayarları
                hazırlanıyor.
              </div>

              <div className="mt-5 h-2 overflow-hidden rounded-full bg-slate-100">
                <div className="h-full w-2/3 animate-pulse rounded-full bg-gradient-to-r from-blue-600 to-orange-500" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}